(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnk-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const video = document.querySelector('.kam-video-widget__video');
  const audio = document.getElementById('bnk-bg-audio');
  const btn   = document.getElementById('bnk-sound-toggle');
  /* HET BESTAND IS AL GEKNIPT, ER WORDT NERGENS MEER GESPRONGEN.

     Eerder laadden we het hele nummer en sprongen we naar het afgesproken punt. Dat
     werkte op de computer en niet op de telefoon, en de reden is fundamenteel: iOS
     weigert een sprong naar het midden van een bestand zolang dat stuk niet binnen
     is, en bij een bestand van megabytes duurt dat op mobiel internet te lang. Elke
     reparatie daaraan was symptoombestrijding.

     Nu staat het afgesproken fragment als eigen bestand op de site en begint het bij
     nul. Nul is altijd onmiddellijk beschikbaar, op elk toestel. Herhalen doet het
     loop-attribuut op het audio-element, dus ook de terugsprong aan het eind is weg.

     Wat er overblijft is alleen nog: op de computer zacht invaden, en op iOS meteen
     aan, want daar is het volume hardware en laat Safari het niet programmeren. */

  const DOEL = 0.45;
  let playing = false;
  let bezig = false;
  let hoorbaar = false;
  let warm = false;
  let laatsteStart = 0;
  const iconOff = btn.querySelector('.kam-sound-btn__icon--off');
  const iconOn  = btn.querySelector('.kam-sound-btn__icon--on');

  function setIcon(on) {
    iconOff.style.display = on ? 'none' : 'flex';
    iconOn.style.display  = on ? 'flex' : 'none';
    btn.classList.toggle('is-playing', on);
    btn.setAttribute('aria-label', on ? (btn.dataset.labelOn || 'Geluid uit') : (btn.dataset.labelOff || 'Geluid aan'));
  }

  /* Voorverwarmen zodra de bezoeker in de buurt komt, nooit op het klikmoment zelf:
     load() gooit een lopende download weg. */
  function warmOp() {
    if (warm) return;
    warm = true;
    try {
      audio.preload = 'auto';
      if (audio.readyState < 1 && audio.networkState !== 2) audio.load();
    } catch (e) {}
  }
  btn.addEventListener('pointerenter', warmOp);
  btn.addEventListener('focus', warmOp);
  btn.addEventListener('touchstart', warmOp, { passive: true });
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((ev) => {
    window.addEventListener(ev, warmOp, { once: true, passive: true });
  });
  const net = navigator.connection || {};
  if (!net.saveData && net.effectiveType !== '2g' && net.effectiveType !== 'slow-2g') {
    setTimeout(warmOp, 1500);
  }

  function startAudio() {
    if (bezig) return;
    bezig = true;
    laatsteStart = Date.now();
    hoorbaar = false;
    setIcon(true);
    audio.preload = 'auto';
    try { audio.currentTime = 0; } catch (e) {}

    /* Op iOS is het volume hardware en wordt deze toekenning genegeerd. Zo merken we
       dat, en dan slaan we het invaden over in plaats van erop te vertrouwen. */
    audio.volume = 0;
    const volumeStuurbaar = (audio.volume === 0);

    function gelukt() {
      bezig = false;
      playing = true;
      setIcon(true);
      if (!volumeStuurbaar) { hoorbaar = true; return; }
      let ms = 0;
      const fade = setInterval(() => {
        ms += 40;
        audio.volume = Math.min(DOEL, DOEL * ms / 200);
        if (ms >= 200) { audio.volume = DOEL; hoorbaar = true; clearInterval(fade); }
      }, 40);
    }

    const poging = audio.play();
    if (!poging || !poging.then) { gelukt(); return; }
    poging.then(gelukt).catch(() => {
      bezig = false; playing = false; hoorbaar = false; setIcon(false);
      if (volumeStuurbaar) audio.volume = DOEL;
    });
  }

  function stopAudio() {
    hoorbaar = false;
    audio.pause();
    playing = false;
    setIcon(false);
  }

  btn.addEventListener('click', function() {
    /* Het juiste criterium is niet hoe snel iemand nog eens tikt, maar of hij al
       iets hoort. Wie nog niets hoort tikt omdat hij geluid wil, niet omdat hij het
       uit wil, dus die tik negeren we. Zodra het volume er echt is telt een tik
       gewoon als uitzetten. De bovengrens van zes seconden zorgt dat de knop nooit
       vast kan komen te zitten als het afspelen helemaal niet lukt. */
    /* 600 ms, omdat een mens geluid niet in minder tijd kan horen, beoordelen en
       erop reageren. Alles binnen dat venster is dus een dubbele tik en geen wens
       om uit te zetten. */
    if (Date.now() - laatsteStart < 600) return;
    if (playing && !hoorbaar && Date.now() - laatsteStart < 6000) return;
    if (playing) { stopAudio(); } else { startAudio(); }
  });

  // Start audio na eerste gebruikersinteractie op de pagina
  function onFirstInteraction() {
    document.removeEventListener('click', onFirstInteraction);
    document.removeEventListener('keydown', onFirstInteraction);
    document.removeEventListener('touchstart', onFirstInteraction);
  }
  document.addEventListener('click', onFirstInteraction, { once: true });
  document.addEventListener('keydown', onFirstInteraction, { once: true });
  document.addEventListener('touchstart', onFirstInteraction, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function() {
  const audio  = document.getElementById('bnk-hiw-audio');
  const btn    = document.getElementById('bnk-hiw-sound-toggle');
  if (!audio || !btn) return;

  /* HET BESTAND IS AL GEKNIPT, ER WORDT NERGENS MEER GESPRONGEN.

     Eerder laadden we het hele nummer en sprongen we naar het afgesproken punt. Dat
     werkte op de computer en niet op de telefoon, en de reden is fundamenteel: iOS
     weigert een sprong naar het midden van een bestand zolang dat stuk niet binnen
     is, en bij een bestand van megabytes duurt dat op mobiel internet te lang. Elke
     reparatie daaraan was symptoombestrijding.

     Nu staat het afgesproken fragment als eigen bestand op de site en begint het bij
     nul. Nul is altijd onmiddellijk beschikbaar, op elk toestel. Herhalen doet het
     loop-attribuut op het audio-element, dus ook de terugsprong aan het eind is weg.

     Wat er overblijft is alleen nog: op de computer zacht invaden, en op iOS meteen
     aan, want daar is het volume hardware en laat Safari het niet programmeren. */

  const DOEL = 0.45;
  let playing = false;
  let bezig = false;
  let hoorbaar = false;
  let warm = false;
  let laatsteStart = 0;
  const iconOff = btn.querySelector('.kam-sound-btn__icon--off');
  const iconOn  = btn.querySelector('.kam-sound-btn__icon--on');

  function setIcon(on) {
    iconOff.style.display = on ? 'none' : 'flex';
    iconOn.style.display  = on ? 'flex' : 'none';
    btn.classList.toggle('is-playing', on);
    btn.setAttribute('aria-label', on ? 'Geluid uit' : 'Geluid aan');
  }

  /* Voorverwarmen zodra de bezoeker in de buurt komt, nooit op het klikmoment zelf:
     load() gooit een lopende download weg. */
  function warmOp() {
    if (warm) return;
    warm = true;
    try {
      audio.preload = 'auto';
      if (audio.readyState < 1 && audio.networkState !== 2) audio.load();
    } catch (e) {}
  }
  btn.addEventListener('pointerenter', warmOp);
  btn.addEventListener('focus', warmOp);
  btn.addEventListener('touchstart', warmOp, { passive: true });
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((ev) => {
    window.addEventListener(ev, warmOp, { once: true, passive: true });
  });
  const net = navigator.connection || {};
  if (!net.saveData && net.effectiveType !== '2g' && net.effectiveType !== 'slow-2g') {
    setTimeout(warmOp, 1500);
  }

  function startAudio() {
    if (bezig) return;
    bezig = true;
    laatsteStart = Date.now();
    hoorbaar = false;
    setIcon(true);
    audio.preload = 'auto';
    try { audio.currentTime = 0; } catch (e) {}

    /* Op iOS is het volume hardware en wordt deze toekenning genegeerd. Zo merken we
       dat, en dan slaan we het invaden over in plaats van erop te vertrouwen. */
    audio.volume = 0;
    const volumeStuurbaar = (audio.volume === 0);

    function gelukt() {
      bezig = false;
      playing = true;
      setIcon(true);
      if (!volumeStuurbaar) { hoorbaar = true; return; }
      let ms = 0;
      const fade = setInterval(() => {
        ms += 40;
        audio.volume = Math.min(DOEL, DOEL * ms / 200);
        if (ms >= 200) { audio.volume = DOEL; hoorbaar = true; clearInterval(fade); }
      }, 40);
    }

    const poging = audio.play();
    if (!poging || !poging.then) { gelukt(); return; }
    poging.then(gelukt).catch(() => {
      bezig = false; playing = false; hoorbaar = false; setIcon(false);
      if (volumeStuurbaar) audio.volume = DOEL;
    });
  }

  function stopAudio() {
    hoorbaar = false;
    audio.pause();
    playing = false;
    setIcon(false);
  }

  btn.addEventListener('click', function() {
    /* Het juiste criterium is niet hoe snel iemand nog eens tikt, maar of hij al
       iets hoort. Wie nog niets hoort tikt omdat hij geluid wil, niet omdat hij het
       uit wil, dus die tik negeren we. Zodra het volume er echt is telt een tik
       gewoon als uitzetten. De bovengrens van zes seconden zorgt dat de knop nooit
       vast kan komen te zitten als het afspelen helemaal niet lukt. */
    /* 600 ms, omdat een mens geluid niet in minder tijd kan horen, beoordelen en
       erop reageren. Alles binnen dat venster is dus een dubbele tik en geen wens
       om uit te zetten. */
    if (Date.now() - laatsteStart < 600) return;
    if (playing && !hoorbaar && Date.now() - laatsteStart < 6000) return;
    if (playing) { stopAudio(); } else { startAudio(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-kam-demo"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Scroll animatie ──────────────────────────────────
  const container = document.getElementById('bnk-demo-scroll');
  const card      = document.getElementById('bnk-demo-card');
  const header    = document.getElementById('bnk-demo-header');
  if (!container || !card || !header) return;

  function updateScroll() {
    const rect     = container.getBoundingClientRect();
    const contH    = container.offsetHeight;
    const viewH    = window.innerHeight;
    const rawProg  = -rect.top / (contH - viewH);
    const progress = Math.max(0, Math.min(1, rawProg));
    const t        = Math.min(progress / 0.5, 1); // [0,0.5] -> [0,1]

    const rotateX  = 20 * (1 - t);
    const scale    = 1.05 - 0.05 * t;
    const transY   = -100 * t;

    card.style.transform   = 'rotateX(' + rotateX + 'deg) scale(' + scale + ')';
    header.style.transform = 'translateY(' + transY + 'px)';
  }

  window.addEventListener('scroll', updateScroll, { passive: true });
  updateScroll();

  // ── Matrix regen ─────────────────────────────────────
  const canvas = document.getElementById('bnk-demo-matrix');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const CHARS =
    'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン' +
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*()';

  const fontSize = 11;
  let animId, drops = [], colColor = [];

  function resize() {
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }

  function initCols() {
    const n  = Math.floor(canvas.width / fontSize);
    drops    = Array.from({ length: n }, () => Math.floor(Math.random() * -50));
    colColor = Array.from({ length: n }, (_, i) => i % 2 === 0 ? 'blue' : 'red');
  }

  const BLUE = 'rgba(0, 168, 255, 0.80)';
  const RED  = 'rgba(255, 32, 64, 0.80)';
  let frame  = 0;
  const SKIP = 5;

  function draw() {
    frame++;
    if (frame % SKIP !== 0) { animId = requestAnimationFrame(draw); return; }
    ctx.fillStyle = 'rgba(8,8,8,0.04)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = fontSize + 'px monospace';
    const n = Math.floor(canvas.width / fontSize);
    while (drops.length < n) { drops.push(0); colColor.push(drops.length % 2 === 0 ? 'blue' : 'red'); }
    for (let i = 0; i < n; i++) {
      const char = CHARS[Math.floor(Math.random() * CHARS.length)];
      const isHead = drops[i] > 1 && Math.random() > 0.95;
      ctx.fillStyle = isHead ? '#FFF' : (colColor[i] === 'blue' ? BLUE : RED);
      ctx.fillText(char, i * fontSize, drops[i] * fontSize);
      if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) drops[i] = 0;
      drops[i]++;
    }
    animId = requestAnimationFrame(draw);
  }

  resize(); initCols(); draw();

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { if (!animId) { resize(); initCols(); draw(); } }
      else { cancelAnimationFrame(animId); animId = null; }
    });
  }, { threshold: 0.1 });
  obs.observe(canvas);
  window.addEventListener('resize', () => { resize(); initCols(); });

  // ── Typewriter ────────────────────────────────────────
  const el = document.getElementById('bnk-demo-typewriter');
  if (!el) return;

  const TEXT      = 'STAY CALM, WE HAVE A PLAN!';
  const TYPE_MS   = 65;
  const DELETE_MS = 35;
  const PAUSE_END = 2200;
  const PAUSE_DEL = 500;
  let pos = 0, deleting = false;

  function tick() {
    if (!deleting) {
      el.textContent = TEXT.slice(0, pos + 1);
      pos++;
      if (pos === TEXT.length) { deleting = true; setTimeout(tick, PAUSE_END); return; }
      setTimeout(tick, TYPE_MS);
    } else {
      el.textContent = TEXT.slice(0, pos - 1);
      pos--;
      if (pos === 0) { deleting = false; setTimeout(tick, PAUSE_DEL); return; }
      setTimeout(tick, DELETE_MS);
    }
  }
  setTimeout(tick, 1200);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-kam-systems"] && !Shopify.designMode) return;
  try {
    
(function() {
  var audio = document.getElementById('bnk-systems-audio');
  var btn   = document.getElementById('bnk-systems-sound-toggle');
  if (!audio || !btn) return;

  /* HET BESTAND IS AL GEKNIPT, ER WORDT NERGENS MEER GESPRONGEN.

     Eerder laadden we het hele nummer en sprongen we naar het afgesproken punt. Dat
     werkte op de computer en niet op de telefoon, en de reden is fundamenteel: iOS
     weigert een sprong naar het midden van een bestand zolang dat stuk niet binnen
     is, en bij een bestand van megabytes duurt dat op mobiel internet te lang. Elke
     reparatie daaraan was symptoombestrijding.

     Nu staat het afgesproken fragment als eigen bestand op de site en begint het bij
     nul. Nul is altijd onmiddellijk beschikbaar, op elk toestel. Herhalen doet het
     loop-attribuut op het audio-element, dus ook de terugsprong aan het eind is weg.

     Wat er overblijft is alleen nog: op de computer zacht invaden, en op iOS meteen
     aan, want daar is het volume hardware en laat Safari het niet programmeren. */

  var DOEL = 0.85;
  var playing = false;
  var bezig = false;
  var hoorbaar = false;
  var warm = false;
  var laatsteStart = 0;
  var iconOff = btn.querySelector('.kam-sound-btn__icon--off');
  var iconOn  = btn.querySelector('.kam-sound-btn__icon--on');

  function setIcon(on) {
    iconOff.style.display = on ? 'none' : 'flex';
    iconOn.style.display  = on ? 'flex' : 'none';
    btn.classList.toggle('is-playing', on);
    btn.setAttribute('aria-label', on ? (btn.getAttribute('data-label-on') || 'Geluid uit') : (btn.getAttribute('data-label-off') || 'Geluid aan'));
  }

  /* Voorverwarmen zodra de bezoeker in de buurt komt, nooit op het klikmoment zelf:
     load() gooit een lopende download weg. */
  function warmOp() {
    if (warm) return;
    warm = true;
    try {
      audio.preload = 'auto';
      if (audio.readyState < 1 && audio.networkState !== 2) audio.load();
    } catch (e) {}
  }
  btn.addEventListener('pointerenter', warmOp);
  btn.addEventListener('focus', warmOp);
  btn.addEventListener('touchstart', warmOp, { passive: true });
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function(ev) {
    window.addEventListener(ev, warmOp, { once: true, passive: true });
  });
  var net = navigator.connection || {};
  if (!net.saveData && net.effectiveType !== '2g' && net.effectiveType !== 'slow-2g') {
    setTimeout(warmOp, 1500);
  }

  function startAudio() {
    if (bezig) return;
    bezig = true;
    laatsteStart = Date.now();
    hoorbaar = false;
    setIcon(true);
    audio.preload = 'auto';
    try { audio.currentTime = 0; } catch (e) {}

    /* Op iOS is het volume hardware en wordt deze toekenning genegeerd. Zo merken we
       dat, en dan slaan we het invaden over in plaats van erop te vertrouwen. */
    audio.volume = 0;
    var volumeStuurbaar = (audio.volume === 0);

    function gelukt() {
      bezig = false;
      playing = true;
      setIcon(true);
      if (!volumeStuurbaar) { hoorbaar = true; return; }
      var ms = 0;
      var fade = setInterval(function() {
        ms += 40;
        audio.volume = Math.min(DOEL, DOEL * ms / 200);
        if (ms >= 200) { audio.volume = DOEL; hoorbaar = true; clearInterval(fade); }
      }, 40);
    }

    var poging = audio.play();
    if (!poging || !poging.then) { gelukt(); return; }
    poging.then(gelukt).catch(function() {
      bezig = false; playing = false; hoorbaar = false; setIcon(false);
      if (volumeStuurbaar) audio.volume = DOEL;
    });
  }

  function stopAudio() {
    hoorbaar = false;
    audio.pause();
    playing = false;
    setIcon(false);
  }

  btn.addEventListener('click', function() {
    /* Het juiste criterium is niet hoe snel iemand nog eens tikt, maar of hij al
       iets hoort. Wie nog niets hoort tikt omdat hij geluid wil, niet omdat hij het
       uit wil, dus die tik negeren we. Zodra het volume er echt is telt een tik
       gewoon als uitzetten. De bovengrens van zes seconden zorgt dat de knop nooit
       vast kan komen te zitten als het afspelen helemaal niet lukt. */
    /* 600 ms, omdat een mens geluid niet in minder tijd kan horen, beoordelen en
       erop reageren. Alles binnen dat venster is dus een dubbele tik en geen wens
       om uit te zetten. */
    if (Date.now() - laatsteStart < 600) return;
    if (playing && !hoorbaar && Date.now() - laatsteStart < 6000) return;
    if (playing) { stopAudio(); } else { startAudio(); }
  });
})();

/* Hover-play video-achtergrond op projectkaarten (B-069) */
(function() {
  var cards = document.querySelectorAll('.bnk-system-card.has-video');
  if (!cards.length) return;
  cards.forEach(function(card) {
    var v = card.querySelector('.bnk-system-card__video-el');
    if (!v) return;
    var loaded = false;
    function play() {
      if (!loaded) { v.src = v.getAttribute('data-src'); loaded = true; }
      var p = v.play();
      if (p && p.catch) { p.catch(function() {}); }
    }
    function stop() { try { v.pause(); } catch (e) {} }
    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', stop);
  });
})();

/* Terug-naar-portfolio geheugen: bewaar het actieve filter + de scrollpositie bij het
   verlaten van de portfolio, en herstel ze wanneer je terugkomt vanaf een projectpagina.
   Zo landt "Terug naar Portfolio" precies waar je was (bv. filter Juridisch, op de YASA-kaart). */
(function() {
  var grid = document.querySelector('.bnk-systems__grid');
  if (!grid) return;
  var KEY = 'bnkPortfolioReturn';

  function activeFilter() {
    var b = document.querySelector('.bnk-systems__filter.is-active');
    return b ? b.getAttribute('data-bnk-filter') : 'all';
  }

  window.addEventListener('pagehide', function() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ f: activeFilter(), y: window.scrollY || window.pageYOffset || 0 })); } catch (e) {}
  });

  function restore() {
    // ALLEEN herstellen wanneer je via de "Terug naar Portfolio"-knop komt (die stuurt
    // ?return=1 mee). Zo scrollt het topmenu "KAM Portfolio" gewoon naar bovenaan.
    if (location.search.indexOf('return=1') === -1) return;
    // De parameter meteen uit de URL halen, zodat een refresh niet opnieuw herstelt.
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    var raw; try { raw = sessionStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    var s; try { s = JSON.parse(raw); } catch (e) { return; }
    try { sessionStorage.removeItem(KEY); } catch (e) {}

    if (s.f && s.f !== 'all') {
      var btn = document.querySelector('.bnk-systems__filter[data-bnk-filter="' + s.f + '"]');
      if (btn) btn.click();
    }
    if (typeof s.y === 'number' && s.y > 0) {
      var to = function() { window.scrollTo(0, s.y); };
      to();
      requestAnimationFrame(function() { requestAnimationFrame(to); });
    }
  }

  if (document.readyState === 'complete') restore();
  else window.addEventListener('load', restore);
})();

/* Sector-doorlink: past het filter uit de ?filter=-parameter meteen toe (vanaf de
   home-sectorkaarten), klikt de juiste filterknop en scrollt naar de gefilterde kaarten. */
(function() {
  function applyFilterFromUrl() {
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    var f = params.get('filter');
    if (!f) return;
    var btns = document.querySelectorAll('.bnk-systems__filter');
    var matched = null;
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-bnk-filter') === f) { matched = btns[i]; break; }
    }
    if (!matched) return;
    matched.click();
    // Parameter uit de URL halen zodat een refresh niet opnieuw scrollt.
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    var target = document.querySelector('.bnk-systems__filters') || document.querySelector('.bnk-systems__grid');
    if (!target) return;
    var doScroll = function() {
      var y = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - 90;
      window.scrollTo(0, Math.max(0, y));
    };
    requestAnimationFrame(function() { requestAnimationFrame(doScroll); });
  }
  if (document.readyState === 'complete') applyFilterFromUrl();
  else window.addEventListener('load', applyFilterFromUrl);
})();

/* Vergadering 025 — echte projectkaarten (met bewijsregel) lijnen hun tekstblokken PER RIJ
   uit op gelijke hoogte, zodat titel, omschrijving, "wat het oplost" en bewijsregel over de
   kaarten heen op één lijn staan (en daarmee ook de knop). Robuust: meet de langste per rij
   (bv. Tonyukuk) en zet de andere op die min-height. Alleen desktop (meerkoloms); herberekent
   bij resize en zodra de fonts geladen zijn. */
(function() {
  var grid = document.querySelector('.bnk-systems__grid');
  if (!grid) return;
  var PARTS = ['.bnk-system-card__name', '.bnk-system-card__desc', '.bnk-system-card__solves', '.bnk-system-card__metric'];

  function reset(cards) {
    cards.forEach(function(c) {
      PARTS.forEach(function(sel) {
        var el = c.querySelector(sel);
        if (el) el.style.minHeight = '';
      });
    });
  }

  function equalize() {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bnk-system-card'));
    reset(cards);
    if (window.innerWidth < 901) return;
    // Groepeer per visuele rij op offsetTop (niet beïnvloed door reveal-transforms).
    var rows = {};
    cards.forEach(function(c) {
      var key = c.offsetTop;
      (rows[key] = rows[key] || []).push(c);
    });
    Object.keys(rows).forEach(function(key) {
      var group = rows[key];
      PARTS.forEach(function(sel) {
        var max = 0;
        group.forEach(function(c) {
          var el = c.querySelector(sel);
          if (el) max = Math.max(max, el.offsetHeight);
        });
        if (max > 0) {
          group.forEach(function(c) {
            var el = c.querySelector(sel);
            if (el) el.style.minHeight = max + 'px';
          });
        }
      });
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(equalize, 120); }
  window.addEventListener('load', equalize);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(equalize); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-legatus-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-legatus-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-legatus-lightbox__img');
  var cap = box.querySelector('.bnk-legatus-lightbox__caption');
  var current = 0;

  function captionFor(img) {
    var fig = img.closest('figure');
    var fc = fig ? fig.querySelector('figcaption') : null;
    return fc ? fc.textContent : (img.getAttribute('alt') || '');
  }
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    boxImg.src = imgs[current].src;
    boxImg.alt = imgs[current].alt || '';
    cap.textContent = captionFor(imgs[current]);
  }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  imgs.forEach(function(img, i) {
    img.addEventListener('click', function() { open(i); });
  });
  box.querySelector('.bnk-legatus-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-legatus-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-legatus-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Scrollspy voor de ankernavigatie */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-legatus-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) {
    var id = (a.getAttribute('href') || '').replace('#', '');
    var el = id && document.getElementById(id);
    if (el) { map[id] = a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var a = map[e.target.id];
      if (!a || a === current) return;
      if (current) current.classList.remove('is-current');
      a.classList.add('is-current');
      current = a;
    });
  }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop */
(function() {
  var btn = document.querySelector('.bnk-legatus-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-mizan-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-mizan-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-mizan-lightbox__img');
  var cap = box.querySelector('.bnk-mizan-lightbox__caption');
  var current = 0;

  function captionFor(img) {
    var fig = img.closest('figure');
    var fc = fig ? fig.querySelector('figcaption') : null;
    return fc ? fc.textContent : (img.getAttribute('alt') || '');
  }
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    boxImg.src = imgs[current].src;
    boxImg.alt = imgs[current].alt || '';
    cap.textContent = captionFor(imgs[current]);
  }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  imgs.forEach(function(img, i) {
    img.addEventListener('click', function() { open(i); });
  });
  box.querySelector('.bnk-mizan-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-mizan-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-mizan-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Scrollspy: licht in de ankernavigatie op welke sectie in beeld is, zodat duidelijk is
   dat dit een klikbaar menu is en waar je je bevindt. */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-mizan-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) {
    var id = (a.getAttribute('href') || '').replace('#', '');
    var el = id && document.getElementById(id);
    if (el) { map[id] = a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var a = map[e.target.id];
      if (!a || a === current) return;
      if (current) current.classList.remove('is-current');
      a.classList.add('is-current');
      current = a;
    });
  }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop: verschijnt zodra je begint te scrollen, scrolt soepel omhoog. */
(function() {
  var btn = document.querySelector('.bnk-mizan-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

/* Peek-carousel(s) met veeg/sleep, pijlen, dots en chips. Actieve slide gecentreerd,
   buren pieken links en rechts. Initialiseert ELKE [data-swipe] onafhankelijk. */
(function() {
  function initSwipe(root) {
  var vp = root.querySelector('.bnk-mizan-swipe__vp');
  var track = root.querySelector('.bnk-mizan-swipe__track');
  var slides = Array.prototype.slice.call(track.querySelectorAll('.bnk-mizan-swipe__slide'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.bnk-mizan-swipe__chip'));
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var n = slides.length;
  if (!n) return;
  var index = 0;

  var dots = slides.map(function(_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'bnk-mizan-swipe__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Ga naar weergave ' + (i + 1));
    d.addEventListener('click', function() { go(i); });
    dotsWrap.appendChild(d);
    return d;
  });

  function step() {
    if (n < 2) return vp.clientWidth;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }
  function baseOffset() {
    var s = slides[index];
    return (vp.clientWidth / 2) - (s.offsetLeft + s.offsetWidth / 2);
  }
  function render(extra) {
    extra = extra || 0;
    track.style.transform = 'translate3d(' + (baseOffset() + extra) + 'px,0,0)';
    slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
    chips.forEach(function(c, i) {
      var on = i === index;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === n - 1;
  }
  function go(i) {
    index = Math.max(0, Math.min(n - 1, i));
    track.style.transition = '';
    render(0);
  }

  prevBtn.addEventListener('click', function() { go(index - 1); });
  nextBtn.addEventListener('click', function() { go(index + 1); });
  chips.forEach(function(c, i) { c.addEventListener('click', function() { go(i); }); });

  // Slepen / vegen
  var dragging = false, startX = 0, dx = 0, moved = false, pid = null;
  function down(x, e) {
    dragging = true; moved = false; startX = x; dx = 0;
    track.style.transition = 'none';
    if (e && e.pointerId != null) { pid = e.pointerId; try { vp.setPointerCapture(pid); } catch (_) {} }
  }
  function move(x) {
    if (!dragging) return;
    dx = x - startX;
    if (Math.abs(dx) > 6) moved = true;
    render(dx);
  }
  function up() {
    if (!dragging) return;
    dragging = false;
    if (pid != null) { try { vp.releasePointerCapture(pid); } catch (_) {} pid = null; }
    var st = step() || 1;
    var jump = Math.round(-dx / st);
    if (jump === 0 && Math.abs(dx) > st * 0.18) jump = dx < 0 ? 1 : -1;
    go(index + jump);
  }
  if (window.PointerEvent) {
    vp.addEventListener('pointerdown', function(e) { if (e.button != null && e.button !== 0) return; down(e.clientX, e); });
    vp.addEventListener('pointermove', function(e) { if (dragging) move(e.clientX); });
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
  } else {
    vp.addEventListener('touchstart', function(e) { down(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchmove', function(e) { move(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchend', up);
    vp.addEventListener('mousedown', function(e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }
  // Klik onderdrukken direct na een sleep (anders opent de lightbox ongewild)
  vp.addEventListener('click', function(e) {
    if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
  }, true);

  // Toetsenbord
  vp.setAttribute('tabindex', '0');
  vp.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
  });

  window.addEventListener('resize', function() { track.style.transition = 'none'; render(0); });
  render(0);
  window.addEventListener('load', function() { render(0); });
  slides.forEach(function(s) {
    var img = s.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function() { render(0); });
  });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-swipe]')).forEach(initSwipe);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-page-consultancy"] && !Shopify.designMode) return;
  try {
    
(function() {
  var audio = document.getElementById('bnk-consultancy-audio');
  var btn   = document.getElementById('bnk-consultancy-sound-toggle');
  if (!audio || !btn) return;

  /* zelfde fragment als de pagina Hoe het werkt, bnk-kemal.mp3 vanaf 2:07.50 */
  /* HET BESTAND IS AL GEKNIPT, ER WORDT NERGENS MEER GESPRONGEN.

     Eerder laadden we het hele nummer en sprongen we naar het afgesproken punt. Dat
     werkte op de computer en niet op de telefoon, en de reden is fundamenteel: iOS
     weigert een sprong naar het midden van een bestand zolang dat stuk niet binnen
     is, en bij een bestand van megabytes duurt dat op mobiel internet te lang. Elke
     reparatie daaraan was symptoombestrijding.

     Nu staat het afgesproken fragment als eigen bestand op de site en begint het bij
     nul. Nul is altijd onmiddellijk beschikbaar, op elk toestel. Herhalen doet het
     loop-attribuut op het audio-element, dus ook de terugsprong aan het eind is weg.

     Wat er overblijft is alleen nog: op de computer zacht invaden, en op iOS meteen
     aan, want daar is het volume hardware en laat Safari het niet programmeren. */

  var DOEL = 0.45;
  var playing = false;
  var bezig = false;
  var hoorbaar = false;
  var warm = false;
  var laatsteStart = 0;
  var iconOff = btn.querySelector('.kam-sound-btn__icon--off');
  var iconOn  = btn.querySelector('.kam-sound-btn__icon--on');

  function setIcon(on) {
    iconOff.style.display = on ? 'none' : 'flex';
    iconOn.style.display  = on ? 'flex' : 'none';
    btn.classList.toggle('is-playing', on);
    btn.setAttribute('aria-label', on ? 'Geluid uit' : 'Geluid aan');
  }

  /* Voorverwarmen zodra de bezoeker in de buurt komt, nooit op het klikmoment zelf:
     load() gooit een lopende download weg. */
  function warmOp() {
    if (warm) return;
    warm = true;
    try {
      audio.preload = 'auto';
      if (audio.readyState < 1 && audio.networkState !== 2) audio.load();
    } catch (e) {}
  }
  btn.addEventListener('pointerenter', warmOp);
  btn.addEventListener('focus', warmOp);
  btn.addEventListener('touchstart', warmOp, { passive: true });
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function(ev) {
    window.addEventListener(ev, warmOp, { once: true, passive: true });
  });
  var net = navigator.connection || {};
  if (!net.saveData && net.effectiveType !== '2g' && net.effectiveType !== 'slow-2g') {
    setTimeout(warmOp, 1500);
  }

  function startAudio() {
    if (bezig) return;
    bezig = true;
    laatsteStart = Date.now();
    hoorbaar = false;
    setIcon(true);
    audio.preload = 'auto';
    try { audio.currentTime = 0; } catch (e) {}

    /* Op iOS is het volume hardware en wordt deze toekenning genegeerd. Zo merken we
       dat, en dan slaan we het invaden over in plaats van erop te vertrouwen. */
    audio.volume = 0;
    var volumeStuurbaar = (audio.volume === 0);

    function gelukt() {
      bezig = false;
      playing = true;
      setIcon(true);
      if (!volumeStuurbaar) { hoorbaar = true; return; }
      var ms = 0;
      var fade = setInterval(function() {
        ms += 40;
        audio.volume = Math.min(DOEL, DOEL * ms / 200);
        if (ms >= 200) { audio.volume = DOEL; hoorbaar = true; clearInterval(fade); }
      }, 40);
    }

    var poging = audio.play();
    if (!poging || !poging.then) { gelukt(); return; }
    poging.then(gelukt).catch(function() {
      bezig = false; playing = false; hoorbaar = false; setIcon(false);
      if (volumeStuurbaar) audio.volume = DOEL;
    });
  }

  function stopAudio() {
    hoorbaar = false;
    audio.pause();
    playing = false;
    setIcon(false);
  }

  btn.addEventListener('click', function() {
    /* Het juiste criterium is niet hoe snel iemand nog eens tikt, maar of hij al
       iets hoort. Wie nog niets hoort tikt omdat hij geluid wil, niet omdat hij het
       uit wil, dus die tik negeren we. Zodra het volume er echt is telt een tik
       gewoon als uitzetten. De bovengrens van zes seconden zorgt dat de knop nooit
       vast kan komen te zitten als het afspelen helemaal niet lukt. */
    /* 600 ms, omdat een mens geluid niet in minder tijd kan horen, beoordelen en
       erop reageren. Alles binnen dat venster is dus een dubbele tik en geen wens
       om uit te zetten. */
    if (Date.now() - laatsteStart < 600) return;
    if (playing && !hoorbaar && Date.now() - laatsteStart < 6000) return;
    if (playing) { stopAudio(); } else { startAudio(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-quantum-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-quantum-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-quantum-lightbox__img');
  var cap = box.querySelector('.bnk-quantum-lightbox__caption');
  var current = 0;

  function captionFor(img) {
    var fig = img.closest('figure');
    var fc = fig ? fig.querySelector('figcaption') : null;
    return fc ? fc.textContent : (img.getAttribute('alt') || '');
  }
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    boxImg.src = imgs[current].src;
    boxImg.alt = imgs[current].alt || '';
    cap.textContent = captionFor(imgs[current]);
  }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  imgs.forEach(function(img, i) {
    img.addEventListener('click', function() { open(i); });
  });
  box.querySelector('.bnk-quantum-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-quantum-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-quantum-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Scrollspy: licht in de ankernavigatie op welke sectie in beeld is, zodat duidelijk is
   dat dit een klikbaar menu is en waar je je bevindt. */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-quantum-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) {
    var id = (a.getAttribute('href') || '').replace('#', '');
    var el = id && document.getElementById(id);
    if (el) { map[id] = a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var a = map[e.target.id];
      if (!a || a === current) return;
      if (current) current.classList.remove('is-current');
      a.classList.add('is-current');
      current = a;
    });
  }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop: verschijnt zodra je begint te scrollen, scrolt soepel omhoog. */
(function() {
  var btn = document.querySelector('.bnk-quantum-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

/* Peek-carousel(s) met veeg/sleep, pijlen, dots en chips. Actieve slide gecentreerd,
   buren pieken links en rechts. Initialiseert ELKE [data-swipe] onafhankelijk. */
(function() {
  function initSwipe(root) {
  var vp = root.querySelector('.bnk-quantum-swipe__vp');
  var track = root.querySelector('.bnk-quantum-swipe__track');
  var slides = Array.prototype.slice.call(track.querySelectorAll('.bnk-quantum-swipe__slide'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.bnk-quantum-swipe__chip'));
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var n = slides.length;
  if (!n) return;
  var index = 0;

  var dots = slides.map(function(_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'bnk-quantum-swipe__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Ga naar weergave ' + (i + 1));
    d.addEventListener('click', function() { go(i); });
    dotsWrap.appendChild(d);
    return d;
  });

  function step() {
    if (n < 2) return vp.clientWidth;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }
  function baseOffset() {
    var s = slides[index];
    return (vp.clientWidth / 2) - (s.offsetLeft + s.offsetWidth / 2);
  }
  function render(extra) {
    extra = extra || 0;
    track.style.transform = 'translate3d(' + (baseOffset() + extra) + 'px,0,0)';
    slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
    chips.forEach(function(c, i) {
      var on = i === index;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === n - 1;
  }
  function go(i) {
    index = Math.max(0, Math.min(n - 1, i));
    track.style.transition = '';
    render(0);
  }

  prevBtn.addEventListener('click', function() { go(index - 1); });
  nextBtn.addEventListener('click', function() { go(index + 1); });
  chips.forEach(function(c, i) { c.addEventListener('click', function() { go(i); }); });

  // Slepen / vegen
  var dragging = false, startX = 0, dx = 0, moved = false, pid = null;
  function down(x, e) {
    dragging = true; moved = false; startX = x; dx = 0;
    track.style.transition = 'none';
    if (e && e.pointerId != null) { pid = e.pointerId; try { vp.setPointerCapture(pid); } catch (_) {} }
  }
  function move(x) {
    if (!dragging) return;
    dx = x - startX;
    if (Math.abs(dx) > 6) moved = true;
    render(dx);
  }
  function up() {
    if (!dragging) return;
    dragging = false;
    if (pid != null) { try { vp.releasePointerCapture(pid); } catch (_) {} pid = null; }
    var st = step() || 1;
    var jump = Math.round(-dx / st);
    if (jump === 0 && Math.abs(dx) > st * 0.18) jump = dx < 0 ? 1 : -1;
    go(index + jump);
  }
  if (window.PointerEvent) {
    vp.addEventListener('pointerdown', function(e) { if (e.button != null && e.button !== 0) return; down(e.clientX, e); });
    vp.addEventListener('pointermove', function(e) { if (dragging) move(e.clientX); });
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
  } else {
    vp.addEventListener('touchstart', function(e) { down(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchmove', function(e) { move(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchend', up);
    vp.addEventListener('mousedown', function(e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }
  // Klik onderdrukken direct na een sleep (anders opent de lightbox ongewild)
  vp.addEventListener('click', function(e) {
    if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
  }, true);

  // Toetsenbord
  vp.setAttribute('tabindex', '0');
  vp.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
  });

  window.addEventListener('resize', function() { track.style.transition = 'none'; render(0); });
  render(0);
  window.addEventListener('load', function() { render(0); });
  slides.forEach(function(s) {
    var img = s.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function() { render(0); });
  });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-swipe]')).forEach(initSwipe);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-servicekosten-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-sk-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-sk-lightbox__img');
  var cap = box.querySelector('.bnk-sk-lightbox__caption');
  var current = 0;
  function captionFor(img) { var f = img.closest('figure'); var fc = f ? f.querySelector('figcaption') : null; return fc ? fc.textContent : (img.getAttribute('alt') || ''); }
  function show(i) { current = (i + imgs.length) % imgs.length; boxImg.src = imgs[current].src; boxImg.alt = imgs[current].alt || ''; cap.textContent = captionFor(imgs[current]); }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  imgs.forEach(function(img, i) { img.addEventListener('click', function() { open(i); }); });
  box.querySelector('.bnk-sk-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-sk-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-sk-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) { if (!box.classList.contains('is-open')) return; if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(current - 1); else if (e.key === 'ArrowRight') show(current + 1); });
})();

/* Scrollspy */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-sk-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) { var id = (a.getAttribute('href') || '').replace('#', ''); var el = id && document.getElementById(id); if (el) { map[id] = a; targets.push(el); } });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) { entries.forEach(function(e) { if (!e.isIntersecting) return; var a = map[e.target.id]; if (!a || a === current) return; if (current) current.classList.remove('is-current'); a.classList.add('is-current'); current = a; }); }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop */
(function() {
  var btn = document.querySelector('.bnk-sk-top');
  if (!btn) return;
  function onScroll() { var y = window.scrollY || window.pageYOffset || 0; btn.classList.toggle('is-visible', y > 260); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  btn.addEventListener('click', function() { var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
})();

/* Peek-carousel(s): veeg/sleep, pijlen, dots, chips. Initialiseert ELKE [data-swipe]. */
(function() {
  function initSwipe(root) {
    var vp = root.querySelector('.bnk-sk-swipe__vp');
    var track = root.querySelector('.bnk-sk-swipe__track');
    if (!vp || !track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.bnk-sk-swipe__slide'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.bnk-sk-swipe__chip'));
    var dotsWrap = root.querySelector('[data-dots]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var n = slides.length;
    if (!n) return;
    var index = 0;

    var dots = slides.map(function(_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'bnk-sk-swipe__dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Ga naar weergave ' + (i + 1));
      d.addEventListener('click', function() { go(i); });
      if (dotsWrap) dotsWrap.appendChild(d);
      return d;
    });

    function step() { if (n < 2) return vp.clientWidth; return slides[1].offsetLeft - slides[0].offsetLeft; }
    function baseOffset() { var s = slides[index]; return (vp.clientWidth / 2) - (s.offsetLeft + s.offsetWidth / 2); }
    function render(extra) {
      extra = extra || 0;
      track.style.transform = 'translate3d(' + (baseOffset() + extra) + 'px,0,0)';
      slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
      chips.forEach(function(c, i) { var on = i === index; c.classList.toggle('is-active', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === n - 1;
    }
    function go(i) { index = Math.max(0, Math.min(n - 1, i)); track.style.transition = ''; render(0); }

    if (prevBtn) prevBtn.addEventListener('click', function() { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { go(index + 1); });
    chips.forEach(function(c, i) { c.addEventListener('click', function() { go(i); }); });

    var dragging = false, startX = 0, dx = 0, moved = false, pid = null;
    function down(x, e) { dragging = true; moved = false; startX = x; dx = 0; track.style.transition = 'none'; if (e && e.pointerId != null) { pid = e.pointerId; try { vp.setPointerCapture(pid); } catch (_) {} } }
    function move(x) { if (!dragging) return; dx = x - startX; if (Math.abs(dx) > 6) moved = true; render(dx); }
    function up() {
      if (!dragging) return;
      dragging = false;
      if (pid != null) { try { vp.releasePointerCapture(pid); } catch (_) {} pid = null; }
      var st = step() || 1;
      var jump = Math.round(-dx / st);
      if (jump === 0 && Math.abs(dx) > st * 0.18) jump = dx < 0 ? 1 : -1;
      go(index + jump);
    }
    if (window.PointerEvent) {
      vp.addEventListener('pointerdown', function(e) { if (e.button != null && e.button !== 0) return; down(e.clientX, e); });
      vp.addEventListener('pointermove', function(e) { if (dragging) move(e.clientX); });
      vp.addEventListener('pointerup', up);
      vp.addEventListener('pointercancel', up);
    } else {
      vp.addEventListener('touchstart', function(e) { down(e.touches[0].clientX); }, { passive: true });
      vp.addEventListener('touchmove', function(e) { move(e.touches[0].clientX); }, { passive: true });
      vp.addEventListener('touchend', up);
      vp.addEventListener('mousedown', function(e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
      window.addEventListener('mouseup', up);
    }
    vp.addEventListener('click', function(e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);

    vp.setAttribute('tabindex', '0');
    vp.addEventListener('keydown', function(e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); } else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); } });

    window.addEventListener('resize', function() { track.style.transition = 'none'; render(0); });
    render(0);
    window.addEventListener('load', function() { render(0); });
    slides.forEach(function(s) { var img = s.querySelector('img'); if (img && !img.complete) img.addEventListener('load', function() { render(0); }); });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-swipe]')).forEach(initSwipe);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-sureflow-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-sureflow-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-sureflow-lightbox__img');
  var cap = box.querySelector('.bnk-sureflow-lightbox__caption');
  var current = 0;

  function captionFor(img) {
    var fig = img.closest('figure');
    var fc = fig ? fig.querySelector('figcaption') : null;
    return fc ? fc.textContent : (img.getAttribute('alt') || '');
  }
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    boxImg.src = imgs[current].src;
    boxImg.alt = imgs[current].alt || '';
    cap.textContent = captionFor(imgs[current]);
  }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  imgs.forEach(function(img, i) {
    img.addEventListener('click', function() { open(i); });
  });
  box.querySelector('.bnk-sureflow-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-sureflow-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-sureflow-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Scrollspy: licht in de ankernavigatie op welke sectie in beeld is, zodat duidelijk is
   dat dit een klikbaar menu is en waar je je bevindt. */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-sureflow-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) {
    var id = (a.getAttribute('href') || '').replace('#', '');
    var el = id && document.getElementById(id);
    if (el) { map[id] = a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var a = map[e.target.id];
      if (!a || a === current) return;
      if (current) current.classList.remove('is-current');
      a.classList.add('is-current');
      current = a;
    });
  }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop: verschijnt zodra je begint te scrollen, scrolt soepel omhoog. */
(function() {
  var btn = document.querySelector('.bnk-sureflow-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

/* Peek-carousel(s) met veeg/sleep, pijlen, dots en chips. Actieve slide gecentreerd,
   buren pieken links en rechts. Initialiseert ELKE [data-swipe] onafhankelijk. */
(function() {
  function initSwipe(root) {
  var vp = root.querySelector('.bnk-sureflow-swipe__vp');
  var track = root.querySelector('.bnk-sureflow-swipe__track');
  var slides = Array.prototype.slice.call(track.querySelectorAll('.bnk-sureflow-swipe__slide'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.bnk-sureflow-swipe__chip'));
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var n = slides.length;
  if (!n) return;
  var index = 0;

  var dots = slides.map(function(_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'bnk-sureflow-swipe__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Ga naar weergave ' + (i + 1));
    d.addEventListener('click', function() { go(i); });
    dotsWrap.appendChild(d);
    return d;
  });

  function step() {
    if (n < 2) return vp.clientWidth;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }
  function baseOffset() {
    var s = slides[index];
    return (vp.clientWidth / 2) - (s.offsetLeft + s.offsetWidth / 2);
  }
  function render(extra) {
    extra = extra || 0;
    track.style.transform = 'translate3d(' + (baseOffset() + extra) + 'px,0,0)';
    slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
    chips.forEach(function(c, i) {
      var on = i === index;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === n - 1;
  }
  function go(i) {
    index = Math.max(0, Math.min(n - 1, i));
    track.style.transition = '';
    render(0);
  }

  prevBtn.addEventListener('click', function() { go(index - 1); });
  nextBtn.addEventListener('click', function() { go(index + 1); });
  chips.forEach(function(c, i) { c.addEventListener('click', function() { go(i); }); });

  // Slepen / vegen
  var dragging = false, startX = 0, dx = 0, moved = false, pid = null;
  function down(x, e) {
    dragging = true; moved = false; startX = x; dx = 0;
    track.style.transition = 'none';
    if (e && e.pointerId != null) { pid = e.pointerId; try { vp.setPointerCapture(pid); } catch (_) {} }
  }
  function move(x) {
    if (!dragging) return;
    dx = x - startX;
    if (Math.abs(dx) > 6) moved = true;
    render(dx);
  }
  function up() {
    if (!dragging) return;
    dragging = false;
    if (pid != null) { try { vp.releasePointerCapture(pid); } catch (_) {} pid = null; }
    var st = step() || 1;
    var jump = Math.round(-dx / st);
    if (jump === 0 && Math.abs(dx) > st * 0.18) jump = dx < 0 ? 1 : -1;
    go(index + jump);
  }
  if (window.PointerEvent) {
    vp.addEventListener('pointerdown', function(e) { if (e.button != null && e.button !== 0) return; down(e.clientX, e); });
    vp.addEventListener('pointermove', function(e) { if (dragging) move(e.clientX); });
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
  } else {
    vp.addEventListener('touchstart', function(e) { down(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchmove', function(e) { move(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchend', up);
    vp.addEventListener('mousedown', function(e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }
  // Klik onderdrukken direct na een sleep (anders opent de lightbox ongewild)
  vp.addEventListener('click', function(e) {
    if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
  }, true);

  // Toetsenbord
  vp.setAttribute('tabindex', '0');
  vp.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
  });

  window.addEventListener('resize', function() { track.style.transition = 'none'; render(0); });
  render(0);
  window.addEventListener('load', function() { render(0); });
  slides.forEach(function(s) {
    var img = s.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function() { render(0); });
  });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-swipe]')).forEach(initSwipe);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-tonyukuk-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-tony-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-tony-lightbox__img');
  var cap = box.querySelector('.bnk-tony-lightbox__caption');
  var current = 0;
  function captionFor(img) { var fig = img.closest('figure'); var fc = fig ? fig.querySelector('figcaption') : null; return fc ? fc.textContent : (img.getAttribute('alt') || ''); }
  function show(i) { current = (i + imgs.length) % imgs.length; boxImg.src = imgs[current].src; boxImg.alt = imgs[current].alt || ''; cap.textContent = captionFor(imgs[current]); }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  imgs.forEach(function(img, i) { img.addEventListener('click', function() { open(i); }); });
  box.querySelector('.bnk-tony-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-tony-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-tony-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) { if (!box.classList.contains('is-open')) return; if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(current - 1); else if (e.key === 'ArrowRight') show(current + 1); });
})();

/* Zwevende "naar boven"-knop: verschijnt zodra je begint te scrollen, scrolt soepel omhoog. */
(function() {
  var btn = document.querySelector('.bnk-tony-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-uiux-design"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Media-bescherming (B-035): stille download-drempel, scoped op de UI/UX-sectie.
     De laptop-preview (KAIROS) draagt zijn eigen bescherming binnen de iframe.
     Let op: afschrikking tegen casual downloaden, geen absolute beveiliging. */
  var proot = document.querySelector('.bnk-page-uiux');
  if (proot) {
    proot.addEventListener('contextmenu', function(e){
      if (e.target.closest('video, img, picture, source, .uxlap, .uxp-hero__visual, .uxp-modal')) e.preventDefault();
    });
    proot.addEventListener('dragstart', function(e){
      if (e.target.closest('video, img, picture, source')) e.preventDefault();
    });
    [].forEach.call(proot.querySelectorAll('video, img'), function(m){
      m.setAttribute('draggable','false');
      if (m.tagName === 'VIDEO'){
        m.setAttribute('controlsList','nodownload noplaybackrate noremoteplayback');
        try{ m.disablePictureInPicture = true; }catch(e){}
      }
    });
  }

  var laptops = Array.prototype.slice.call(document.querySelectorAll('.uxlap'));
  if (!laptops.length) return;

  /* Mobiel-fix (B-143): de 7 zware live-preview iframes alleen op desktop activeren.
     Op mobiel blijven de statische posters staan, zodat iOS Safari de tab niet crasht door geheugengebrek. */
  var allowLive = window.matchMedia('(min-width: 901px)').matches;
  if (allowLive) {
    laptops.forEach(function(lap) {
      /* Laptops met data-poster tonen in het raster hun poster en worden pas live
         zodra de bezoeker ze opent. Nodig wanneer de sterkste scene van een demo
         niet bovenaan de pagina staat, zoals bij ANKA Garage. */
      if (lap.hasAttribute('data-poster')) return;
      var f = lap.querySelector('iframe[data-srcdoc]');
      if (f && !f.getAttribute('srcdoc')) { f.setAttribute('srcdoc', f.getAttribute('data-srcdoc')); }
      lap.classList.add('is-live');
    });
  }

  /* Schaal de mini-pagina in elk laptopscherm naar de schermbreedte (logische breedte 1280). */
  var LOGICAL = 1280;
  function scaleOne(lap) {
    var screen = lap.querySelector('.uxlap__screen');
    var stage = lap.querySelector('.uxlap__stage');
    if (!screen || !stage) return;
    var s = screen.clientWidth / LOGICAL;
    stage.style.transform = 'scale(' + s + ')';
  }
  function scaleAll() { laptops.forEach(scaleOne); }
  scaleAll();
  window.addEventListener('resize', scaleAll, { passive: true });
  window.addEventListener('load', scaleAll);
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(scaleAll);
    laptops.forEach(function(l) { var sc = l.querySelector('.uxlap__screen'); if (sc) ro.observe(sc); });
  }

  /* Preview modal */
  var modal = document.getElementById('uxp-modal');
  var frame = document.getElementById('uxp-modal-frame');
  var urlEl = document.getElementById('uxp-modal-url');
  var closeBtn = document.getElementById('uxp-modal-close');
  if (!modal || !frame) return;

  function open(lap) {
    var iframe = lap.querySelector('iframe');
    /* srcdoc is op desktop gezet; op mobiel is de laptop-iframe inert, dus lees de inhoud uit data-srcdoc (B-143) */
    var html = iframe ? (iframe.getAttribute('srcdoc') || iframe.getAttribute('data-srcdoc') || '') : '';
    if (html) frame.srcdoc = html.replace(/<body/i, '<body data-uxfull="1"');
    /* adres bewust verborgen door BNK KAM: geen echte URL tonen (statisch "Adres verborgen") */
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    frame.removeAttribute('srcdoc');
    document.body.style.overflow = '';
  }
  laptops.forEach(function(lap) {
    lap.addEventListener('click', function() { open(lap); });
  });
  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function(e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
})();

/* ===== Referentie-slider (B-064): sleep, snap, pijlen, voortgang, klik-vs-sleep ===== */
(function(){
  var slider = document.querySelector('.uxp-work__slider');
  if (!slider) return;
  var vp = slider.querySelector('.uxp-work__viewport');
  var track = slider.querySelector('.uxp-work__grid');
  var prev = slider.querySelector('.uxp-work__nav--prev');
  var next = slider.querySelector('.uxp-work__nav--next');
  var bar = document.getElementById('uxp-work-bar');
  if (!vp || !track) return;
  var items = Array.prototype.slice.call(track.children);
  if (!items.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function base(){ return items[0].offsetLeft; }
  /* De viewport heeft horizontale binnenruimte. De browser rekent die mee in zijn
     eigen snap-positie, wij niet. Zonder deze correctie landt de animatie ernaast
     en trekt de browser hem daarna alsnog recht: een zichtbare tik. */
  function padL(){ var p = parseFloat(getComputedStyle(vp).paddingLeft); return isNaN(p) ? 0 : p; }
  function padR(){ var p = parseFloat(getComputedStyle(vp).paddingRight); return isNaN(p) ? 0 : p; }
  /* B-499: in het Arabisch loopt de rij naar links en telt de browser scrollLeft van nul
     naar min de lengte. Al het rekenwerk hieronder gebeurt daarom in een eigen maat die
     altijd van nul naar de lengte loopt. Zonder dit klemde go() zijn doel af op nul en
     stond de laptoprij in het Arabisch volledig stil, bij pijlen zowel als bij slepen. */
  var rtl = getComputedStyle(vp).direction === 'rtl';
  function huidig(){ return rtl ? -vp.scrollLeft : vp.scrollLeft; }
  function zet(x){ vp.scrollLeft = rtl ? -x : x; }
  function target(it){ return rtl ? (base() - it.offsetLeft + padR()) : (it.offsetLeft - base() + padL()); }
  function step(){ return items.length > 1 ? Math.abs(items[1].offsetLeft - items[0].offsetLeft) : items[0].offsetWidth; }
  /* B-501: Safari bepaalt de max-content-breedte van de rij uit de INHOUD van de kaarten
     en niet uit de breedte die wij ze geven. De rij werd daar 5757px breed terwijl de
     kaarten samen 2574px beslaan, en scrollWidth meldde dus een eind dat helemaal niet te
     bereiken was. Gevolg op de iPhone: bij de laatste kaart stond de balk pas op 43 procent.
     De CSS zet de kaartbreedte nu ook via min-width en max-width vast, want dat is wat de
     max-content-berekening wel volgt, en hieronder meten wij de rij aan de kaarten zelf in
     plaats van aan scrollWidth. Twee sloten op dezelfde deur, met opzet. */
  function inhoudBreedte(){
    if (!items.length) return vp.scrollWidth;
    var links = Infinity, rechts = -Infinity;
    items.forEach(function(it){ links = Math.min(links, it.offsetLeft); rechts = Math.max(rechts, it.offsetLeft + it.offsetWidth); });
    return Math.max(vp.clientWidth, rechts - links + padL() + padR());
  }
  function maxScroll(){ return Math.max(0, Math.min(vp.scrollWidth - vp.clientWidth, inhoudBreedte() - vp.clientWidth)); }

  function update(){
    var max = maxScroll(), x = huidig();
    if (prev) prev.disabled = x <= 8;
    if (next) next.disabled = x >= max - 8;
    if (bar){
      /* B-500: de balk wordt gezet met left in procenten van het SPOOR, niet met een
         translateX in procenten van zijn eigen breedte. Die tweede vorm rekent om via
         (100 - w) / w * 100, en zodra w door de ondergrens van 14 procent wordt geklemd
         loopt dat uit de pas: de balk kwam niet aan het eind uit terwijl de rij dat wel
         was. In het Arabisch begint hij rechts en loopt hij naar links. */
      var w = Math.max(14, Math.min(100, (vp.clientWidth / inhoudBreedte()) * 100));
      var frac = max > 0 ? Math.min(1, Math.max(0, x / max)) : 0;
      bar.style.width = w + '%';
      bar.style.left = ((rtl ? 1 - frac : frac) * (100 - w)) + '%';
      bar.style.transform = 'none';
    }
  }
  vp.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  /* wordt verderop gevuld zodra de sleepcode is opgebouwd */
  var glijNaar = null;
  /* B-313: de pijlen gebruiken dezelfde vloeiende beweging als het slepen. */
  function go(dir){
    if (reduce || !glijNaar){ vp.scrollBy({ left: (rtl ? -dir : dir) * step(), behavior: reduce ? 'auto' : 'smooth' }); return; }
    var mx = Math.max(0, maxScroll());
    glijNaar(Math.max(0, Math.min(huidig() + dir * step(), mx)), 0);
  }
  if (prev) prev.addEventListener('click', function(){ go(-1); });
  if (next) next.addEventListener('click', function(){ go(1); });

  /* pijlen verticaal centreren op het laptopscherm, niet op de hele kaart */
  function placeArrows(){
    var dev = slider.querySelector('.uxlap__device');
    if (!dev) return;
    var d = dev.getBoundingClientRect(), s = slider.getBoundingClientRect();
    if (!d.height) return;
    var top = (d.top - s.top) + d.height / 2;
    if (prev) prev.style.top = top + 'px';
    if (next) next.style.top = top + 'px';
    update();
  }
  window.addEventListener('load', placeArrows);
  window.addEventListener('resize', placeArrows);
  var firstImg = slider.querySelector('.uxlap__device');
  if (firstImg && !firstImg.complete) firstImg.addEventListener('load', placeArrows);
  setTimeout(placeArrows, 250); setTimeout(placeArrows, 800); update();

  /* drag-to-scroll (muis/pen); touch gebruikt native scroll */
  var down = false, startX = 0, startLeft = 0, dragged = false;
  var lastX = 0, lastT = 0, vel = 0;      /* snelheid in pixels per milliseconde */
  var raf = 0, wachtX = null, anim = 0;

  function stopAnim(){ if (anim){ cancelAnimationFrame(anim); anim = 0; } }
  function nu(){ return (window.performance && performance.now) ? performance.now() : Date.now(); }

  function dichtstbij(pos){
    var best = target(items[0]), bestD = Infinity;
    items.forEach(function(it){ var t = target(it), dd = Math.abs(t - pos); if (dd < bestD){ bestD = dd; best = t; } });
    return Math.max(0, Math.min(best, maxScroll()));
  }

  /* B-309/B-310: uitrollen met afremming en daarna zacht naar het item, in EEN
     animatie. De browser-snap blijft uit tot die klaar is, anders vechten twee
     mechanismen om dezelfde beweging. */
  glijNaar = function(doel, v0){
    stopAnim();
    if (reduce){ vp.classList.remove('is-glide'); zet(doel === null ? dichtstbij(huidig()) : doel); return; }
    vp.classList.add('is-glide');
    var pos = huidig(), v = v0 || 0, mx = maxScroll(), vast = doel;
    function frame(){
      if (vast === null){                       /* fase 1: uitrollen */
        pos += v; v *= 0.935;
        if (pos < 0){ pos = 0; v = 0; } else if (pos > mx){ pos = mx; v = 0; }
        zet(pos);
        if (Math.abs(v) < 0.7) vast = dichtstbij(pos);
        anim = requestAnimationFrame(frame); return;
      }
      pos += (vast - pos) * 0.17;               /* fase 2: inzakken op het item */
      zet(pos);
      if (Math.abs(vast - pos) < 0.5){
        zet(vast); anim = 0;
        vp.classList.remove('is-glide');
        return;
      }
      anim = requestAnimationFrame(frame);
    }
    anim = requestAnimationFrame(frame);
  };

  vp.addEventListener('pointerdown', function(e){
    if (e.pointerType === 'touch') return;
    stopAnim(); vp.classList.remove('is-glide');
    down = true; dragged = false; startX = e.clientX; startLeft = huidig();
    lastX = e.clientX; lastT = nu(); vel = 0;
    vp.classList.add('is-drag');
  });
  window.addEventListener('pointermove', function(e){
    if (!down) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 5) dragged = true;
    /* snelheid gedempt meten, zodat een trilling van de hand niet doorslaat */
    var t = nu(), dt = t - lastT;
    if (dt > 0){ vel = vel * 0.7 + ((e.clientX - lastX) / dt) * 0.3; lastX = e.clientX; lastT = t; }
    /* B-312: hoogstens een schrijfactie per beeldframe */
    /* Naar rechts slepen brengt in het Arabisch juist de volgende referenties in beeld. */
    wachtX = startLeft + (rtl ? dx : -dx);
    if (!raf) raf = requestAnimationFrame(function(){ raf = 0; if (wachtX !== null) zet(wachtX); });
  });
  function endDrag(){
    if (!down) return;
    down = false;
    if (raf){ cancelAnimationFrame(raf); raf = 0; if (wachtX !== null) zet(wachtX); }
    wachtX = null;
    /* B-311: sleepstijl meteen weg, het uitrollen loopt door */
    vp.classList.remove('is-drag');
    if (!dragged) return;
    if (nu() - lastT > 90) vel = 0;   /* even stilstaan telt als loslaten zonder zwaai */
    glijNaar(null, (rtl ? 1 : -1) * vel * 16);
    setTimeout(function(){ dragged = false; }, 80);
  }
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
  /* onderdruk het openen van de modal direct na een sleep (capture, vóór de .uxlap-klik) */
  vp.addEventListener('click', function(e){
    if (dragged){ e.stopPropagation(); e.preventDefault(); dragged = false; }
  }, true);

  /* toetsenbord */
  vp.setAttribute('tabindex', '0');
  vp.setAttribute('role', 'group');
  vp.setAttribute('aria-label', vp.getAttribute('data-vp-label') || 'Referentie-previews. Sleep, of gebruik de pijltjestoetsen.');
  vp.addEventListener('keydown', function(e){
    if (e.key === 'ArrowRight'){ e.preventDefault(); go(rtl ? -1 : 1); }
    else if (e.key === 'ArrowLeft'){ e.preventDefault(); go(rtl ? 1 : -1); }
  });

  /* ===== Vanzelf doorbladeren =====
     De rij schuift langzaam naar rechts en staat exact stil zodra de muis erop komt.
     De snap blijft uit zolang wij de beweging voeren, anders trekt de browser
     de rij bij elke stap naar het dichtstbijzijnde item en schokt hij. */
  (function(){
    if (reduce) return;
    /* NIET op een aanraakscherm. Deze beweging is bedacht voor een bureaublad, waar hij
       stopt zodra de muis erover komt. Op een telefoon bestaat die pauze niet, dus vocht
       hij tegen elke veeg: de rij kroop terug en het uitlijnen op een laptop stond uit,
       want de klasse is-glide die hij zet, zet scroll-snap-type op none. */
    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    var SNELHEID = 26;          /* pixels per seconde, heen en terug gelijk */
    var stil = false, richting = 1, vorige = 0;
    var modalEl = document.getElementById('uxp-modal');
    /* De browser rondt scrollLeft af op hele pixels. Bij deze snelheid is een stap
       minder dan een pixel, dus die zou elke keer worden weggerond en de rij zou
       stilstaan. Daarom houden wij de positie zelf bij als kommagetal. */
    var pos = 0, gesynct = false, eigenZet = false, hervat = 0;

    function geblokkeerd(){
      return stil || down || anim || document.hidden ||
             (modalEl && modalEl.classList.contains('is-open'));
    }

    function stap(t){
      var dt = vorige ? Math.min(64, t - vorige) : 16;
      vorige = t;
      if (geblokkeerd()){
        gesynct = false;                    /* na een onderbreking opnieuw uitlezen */
      } else {
        var mx = maxScroll();
        if (!gesynct){ pos = huidig(); gesynct = true; }
        if (mx > 2){
          vp.classList.add('is-glide');
          pos += richting * SNELHEID * dt / 1000;
          /* Aan het eind keert hij om en loopt met dezelfde snelheid terug. */
          if (pos >= mx){ pos = mx; richting = -1; }
          else if (pos <= 0){ pos = 0; richting = 1; }
          eigenZet = true;
          zet(pos);
        }
      }
      requestAnimationFrame(stap);
    }

    /* Scrolt de bezoeker de rij zelf, dan is onze opgeslagen positie verouderd. Zonder
       deze regel schrijft de automaat bij de volgende beeldflits zijn eigen oude waarde
       terug en trekt hij de rij onder de hand vandaan. */
    vp.addEventListener('scroll', function(){
      if (eigenZet){ eigenZet = false; return; }
      gesynct = false;
      stil = true;
      clearTimeout(hervat);
      hervat = setTimeout(function(){ stil = false; vorige = 0; }, 3000);
    }, {passive: true});

    ['mouseenter','pointerenter','focusin'].forEach(function(ev){
      slider.addEventListener(ev, function(){ stil = true; });
    });
    ['mouseleave','pointerleave','focusout'].forEach(function(ev){
      slider.addEventListener(ev, function(){ stil = false; vorige = 0; });
    });
    document.addEventListener('visibilitychange', function(){ vorige = 0; });

    requestAnimationFrame(stap);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-vakbib-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bnk-vakbib-catalog]');
  if (!root) return;

  /* ===== Slider: exact hetzelfde systeem als de Webdesign Atelier-referenties ===== */
  var slider = root.querySelector('[data-vakbib-slider]');
  var vp = root.querySelector('.bnk-vakbib-cat__viewport');
  var track = root.querySelector('.bnk-vakbib-cat__grid');
  var prev = root.querySelector('.bnk-vakbib-cat__nav--prev');
  var next = root.querySelector('.bnk-vakbib-cat__nav--next');
  var bar = root.querySelector('[data-vakbib-bar]');
  var allItems = track ? Array.prototype.slice.call(track.children) : [];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasSlider = !!(slider && vp && track && allItems.length);

  function vis() { return allItems.filter(function (it) { return it.style.display !== 'none' && it.offsetParent !== null; }); }
  function base() { var v = vis(); return v.length ? v[0].offsetLeft : 0; }
  /* De viewport heeft horizontale binnenruimte. De browser rekent die mee in zijn
     eigen snap-positie, wij niet. Zonder deze correctie landt onze animatie 6px
     naast de kaart en trekt de browser hem daarna alsnog recht: een zichtbare tik. */
  function padL() { var p = parseFloat(getComputedStyle(vp).paddingLeft); return isNaN(p) ? 0 : p; }
  function padR() { var p = parseFloat(getComputedStyle(vp).paddingRight); return isNaN(p) ? 0 : p; }
  /* B-499: in het Arabisch loopt de rij naar links en telt de browser scrollLeft van
     nul naar min de lengte. Al het rekenwerk hieronder gebeurt daarom in een eigen maat
     die altijd van nul naar de lengte loopt, ongeacht de leesrichting. Zonder dit klemde
     go() zijn doel af op nul en bewogen de pijlen in het Arabisch geen pixel. */
  var rtl = getComputedStyle(vp).direction === 'rtl';
  function huidig() { return rtl ? -vp.scrollLeft : vp.scrollLeft; }
  function zet(x) { vp.scrollLeft = rtl ? -x : x; }
  function target(it) { return rtl ? (base() - it.offsetLeft + padR()) : (it.offsetLeft - base() + padL()); }
  function step() { var v = vis(); return v.length > 1 ? Math.abs(v[1].offsetLeft - v[0].offsetLeft) : (v.length ? v[0].offsetWidth : 320); }
  /* B-501: Safari bepaalt de max-content-breedte van de rij uit de INHOUD van de kaarten
     en niet uit de breedte die wij ze geven. De rij werd daar 5757px breed terwijl de
     kaarten samen 2574px beslaan, en scrollWidth meldde dus een eind dat helemaal niet te
     bereiken was. Gevolg op de iPhone: bij de laatste kaart stond de balk pas op 43 procent.
     De CSS zet de kaartbreedte nu ook via min-width en max-width vast, want dat is wat de
     max-content-berekening wel volgt, en hieronder meten wij de rij aan de kaarten zelf in
     plaats van aan scrollWidth. Twee sloten op dezelfde deur, met opzet. */
  function inhoudBreedte() {
    var v = vis(); if (!v.length) return vp.scrollWidth;
    var links = Infinity, rechts = -Infinity;
    v.forEach(function (it) { links = Math.min(links, it.offsetLeft); rechts = Math.max(rechts, it.offsetLeft + it.offsetWidth); });
    return Math.max(vp.clientWidth, rechts - links + padL() + padR());
  }
  function maxScroll() { return Math.max(0, Math.min(vp.scrollWidth - vp.clientWidth, inhoudBreedte() - vp.clientWidth)); }

  function update() {
    if (!vp) return;
    var max = maxScroll(), x = huidig();
    if (prev) prev.disabled = x <= 8;
    if (next) next.disabled = x >= max - 8;
    if (bar) {
      /* De balk wordt gepositioneerd met left in procenten van het SPOOR, niet met een
         translateX in procenten van zijn eigen breedte. Die tweede vorm rekent om via
         (100 - w) / w * 100, en zodra w door de ondergrens van 14 procent wordt geklemd
         loopt die omrekening uit de pas met de werkelijke breedte. Gevolg: de balk kwam
         niet aan het eind uit terwijl de rij dat wel was. Zo kan dat niet meer. */
      var w = Math.max(14, Math.min(100, (vp.clientWidth / inhoudBreedte()) * 100));
      var frac = max > 0 ? Math.min(1, Math.max(0, x / max)) : 0;
      bar.style.width = w + '%';
      /* In het Arabisch begint de balk rechts en loopt hij naar links. */
      bar.style.left = ((rtl ? 1 - frac : frac) * (100 - w)) + '%';
      bar.style.transform = 'none';
    }
  }
  /* B-313: de pijlen gebruiken dezelfde vloeiende beweging als het slepen, zodat
     de twee helften van de slider niet anders aanvoelen. glijNaar wordt hieronder
     gezet zodra de slider is opgebouwd. */
  var glijNaar = null;
  function go(dir) {
    if (!vp) return;
    if (reduce || !glijNaar) { vp.scrollBy({ left: (rtl ? -dir : dir) * step(), behavior: reduce ? 'auto' : 'smooth' }); return; }
    var mx = Math.max(0, vp.scrollWidth - vp.clientWidth);
    glijNaar(Math.max(0, Math.min(huidig() + dir * step(), mx)), 0);
  }

  /* pijlen verticaal centreren op de cover van de eerste zichtbare kaart */
  function placeArrows() {
    if (!slider) return;
    var v = vis(); var ref = v.length ? v[0].querySelector('.bnk-vakbib-card__cover') : null;
    if (!ref) { update(); return; }
    var d = ref.getBoundingClientRect(), s = slider.getBoundingClientRect();
    if (!d.height) { update(); return; }
    var top = (d.top - s.top) + d.height / 2;
    if (prev) prev.style.top = top + 'px';
    if (next) next.style.top = top + 'px';
    update();
  }

  if (hasSlider) {
    vp.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', placeArrows);
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    window.addEventListener('load', placeArrows);
    setTimeout(placeArrows, 250); setTimeout(placeArrows, 800); update();

    /* drag-to-scroll (muis/pen); touch gebruikt native scroll */
    var down = false, startX = 0, startLeft = 0, dragged = false;
    var lastX = 0, lastT = 0, vel = 0;      /* snelheid in pixels per milliseconde */
    var raf = 0, wachtX = null, anim = 0;

    function stopAnim() { if (anim) { cancelAnimationFrame(anim); anim = 0; } }

    /* dichtstbijzijnde kaart bij een gegeven positie */
    function dichtstbij(pos) {
      var v = vis(); if (!v.length) return pos;
      var best = target(v[0]), bestD = Infinity;
      v.forEach(function (it) { var t = target(it), dd = Math.abs(t - pos); if (dd < bestD) { bestD = dd; best = t; } });
      return Math.max(0, Math.min(best, maxScroll()));
    }

    /* B-309/B-310: uitrollen met afremming en daarna zacht naar de kaart, in
       EEN animatie. De browser-snap blijft uit tot die klaar is, anders vechten
       twee mechanismen om dezelfde beweging. */
    glijNaar = function (doel, v0) {
      stopAnim();
      if (reduce) { vp.classList.remove('is-glide'); zet(doel === null ? dichtstbij(huidig()) : doel); return; }
      vp.classList.add('is-glide');
      var p = huidig(), v = v0 || 0, mx = maxScroll(), vast = doel;
      function frame() {
        if (vast === null) {                      /* fase 1: uitrollen */
          p += v; v *= 0.935;
          if (p < 0) { p = 0; v = 0; } else if (p > mx) { p = mx; v = 0; }
          zet(p);
          if (Math.abs(v) < 0.7) vast = dichtstbij(p);
          anim = requestAnimationFrame(frame); return;
        }
        p += (vast - p) * 0.17;                   /* fase 2: inzakken op de kaart */
        zet(p);
        if (Math.abs(vast - p) < 0.5) {
          zet(vast); anim = 0;
          vp.classList.remove('is-glide');
          return;
        }
        anim = requestAnimationFrame(frame);
      }
      anim = requestAnimationFrame(frame);
    };

    /* B-307: de browser wil een kaartlink of afbeelding zelf gaan slepen en pikt
       daarmee de muisbewegingen in. Afvangen, anders werkt sleep-scrollen niet. */
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      stopAnim(); vp.classList.remove('is-glide');
      down = true; dragged = false; startX = e.clientX; startLeft = huidig();
      lastX = e.clientX; lastT = (window.performance && performance.now) ? performance.now() : Date.now(); vel = 0;
      vp.classList.add('is-drag');
      /* voorkomt de native linksleep, zonder klikken of focus te blokkeren */
      if (e.target.closest('a, img')) e.preventDefault();
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) dragged = true;
      /* snelheid gedempt meten, zodat een trilling van de hand niet doorslaat */
      var nu = (window.performance && performance.now) ? performance.now() : Date.now(), dt = nu - lastT;
      if (dt > 0) { vel = vel * 0.7 + ((e.clientX - lastX) / dt) * 0.3; lastX = e.clientX; lastT = nu; }
      /* B-312: hoogstens een schrijfactie per beeldframe */
      /* Naar rechts slepen brengt in het Arabisch juist de volgende kaarten in beeld. */
      wachtX = startLeft + (rtl ? dx : -dx);
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; if (wachtX !== null) zet(wachtX); });
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (raf) { cancelAnimationFrame(raf); raf = 0; if (wachtX !== null) zet(wachtX); }
      wachtX = null;
      /* B-311: sleepstijl meteen weg, het uitrollen loopt door */
      vp.classList.remove('is-drag');
      if (!dragged) return;
      var stilstand = (window.performance && performance.now) ? performance.now() : Date.now();
      if (stilstand - lastT > 90) vel = 0;      /* even blijven stilstaan telt als loslaten zonder zwaai */
      glijNaar(null, (rtl ? 1 : -1) * vel * 16);
      setTimeout(function () { dragged = false; }, 80);
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    /* onderdruk het volgen van de kaart-link direct na een sleep */
    vp.addEventListener('click', function (e) {
      if (dragged) { e.stopPropagation(); e.preventDefault(); dragged = false; }
    }, true);

    /* toetsenbord */
    vp.setAttribute('tabindex', '0');
    vp.setAttribute('role', 'group');
    vp.setAttribute('aria-label', vp.getAttribute('data-vp-label') || '');
    vp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(rtl ? -1 : 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(rtl ? 1 : -1); }
    });
  }

  /* ===== Filters ===== */
  var chips = root.querySelectorAll('.bnk-vakbib-chip');
  var cards = root.querySelectorAll('.bnk-vakbib-card');
  var noResult = root.querySelector('.bnk-vakbib-cat__noresult');
  var state = { type: 'all', sector: 'all' };

  function apply() {
    var visible = 0;
    cards.forEach(function (card) {
      var okType = state.type === 'all' || card.getAttribute('data-type') === state.type;
      var okSector = state.sector === 'all' || card.getAttribute('data-sector') === state.sector;
      var show = okType && okSector;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    if (noResult) noResult.hidden = visible !== 0;
    if (vp) zet(0);
    placeArrows();
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var filter = chip.getAttribute('data-filter');
      var value = chip.getAttribute('data-value');
      state[filter] = value;
      root.querySelectorAll('.bnk-vakbib-chip[data-filter="' + filter + '"]').forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });
      apply();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-vakbib-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('bnk-vakbib-hero');
  if (!root) return;
  var video = root.querySelector('.bnk-vakbib-hero__video');
  if (!video) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && (navigator.connection.saveData ||
    /2g/.test(navigator.connection.effectiveType || ''));
  if (reduce || saveData) return; // alleen poster tonen

  var loaded = false;
  function loadPlay() {
    if (!loaded) {
      loaded = true;
      var src = video.dataset.src;
      if (src) { video.src = src; video.load(); }
    }
    video.muted = true; video.playsInline = true;
    video.setAttribute('playsinline', '');
    var p = video.play();
    if (p && p.catch) { p.catch(function () {
      video.addEventListener('canplay', function () { video.play().catch(function(){}); }, { once: true });
    }); }
    video.addEventListener('playing', function () { video.classList.add('is-ready'); }, { once: true });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { loadPlay(); } else { video.pause(); }
    });
  }, { rootMargin: '200px', threshold: 0.1 });
  io.observe(video);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { video.pause(); } else if (loaded) { video.play().catch(function(){}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-vakbib-ingangen"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cards = document.querySelectorAll('[data-bnk-vakbib-ingangen] .bnk-vakbib-ing__card');
  if (!cards.length) return;
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var type = card.getAttribute('data-jump-type');
      var chip = document.querySelector('.bnk-vakbib-chip[data-filter="type"][data-value="' + type + '"]');
      if (chip) { setTimeout(function () { chip.click(); }, 120); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-vakbib-manifest"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cats = document.querySelectorAll('.bnk-vakbib-manifest__item--link');
  if (!cats.length) return;
  cats.forEach(function (card) {
    card.addEventListener('click', function () {
      var type = card.getAttribute('data-jump-type');
      var chip = document.querySelector('.bnk-vakbib-chip[data-filter="type"][data-value="' + type + '"]');
      if (chip) { setTimeout(function () { chip.click(); }, 120); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-vakbib-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-vbp]');
  if (!root) return;

  var stage   = [].slice.call(root.querySelectorAll('.vbp__stageimg'));
  var thumbs  = [].slice.call(root.querySelectorAll('.vbp__thumb'));
  var picker  = root.querySelector('[data-vb-picker]');
  var idInput = root.querySelector('[data-vb-id]');
  var amount  = root.querySelector('[data-vb-amount]');
  var bbPrice = root.querySelector('[data-vb-bbprice]');
  var bbMeta  = root.querySelector('[data-vb-bbmeta]');
  var frags   = [].slice.call(root.querySelectorAll('.vbp__fragpage'));
  var fragDl  = [].slice.call(root.querySelectorAll('.vbp__dlbtn'));
  var rtl     = document.documentElement.getAttribute('dir') === 'rtl';

  /* ---------- galerij ---------- */
  function wissel(i) {
    stage.forEach(function (el) { el.classList.toggle('is-active', el.dataset.index === String(i)); });
    thumbs.forEach(function (el) { el.classList.toggle('is-active', el.dataset.index === String(i)); });
  }
  function show(i) {
    /* Altijd meteen omwisselen. Eerder wachtte deze functie eerst op decode() van het nieuwe
       beeld, en dat is een belofte die bij een beeld dat nog op display:none staat niet
       gegarandeerd wordt afgehandeld. Bleef hij hangen, dan wisselden de duimnagels wel maar
       het grote beeld niet, en werkten de pijlen ook niet meer. Decoderen gebeurt nu nog wel,
       maar als hint erna, niet als voorwaarde vooraf. */
    wissel(i);
    var doel = null;
    stage.forEach(function (el) { if (el.dataset.index === String(i)) doel = el; });
    if (doel && doel.decode && !doel.complete) {
      try { doel.decode().catch(function () {}); } catch (e) { /* oudere browser */ }
    }
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.index); }); });

  /* De overige hoofdbeelden op een rustig moment alvast ophalen, zodat doorklikken
     meteen raak is. Stond in de vorige versie en was bij de herbouw weggevallen. */
  (function () {
    function warm() {
      stage.forEach(function (el) {
        var u = el.getAttribute('src');
        if (!u) return;
        var im = new Image();
        im.decoding = 'async';
        im.src = u;
      });
    }
    if ('requestIdleCallback' in window) { requestIdleCallback(warm, { timeout: 1500 }); }
    else { setTimeout(warm, 700); }
  })();

  function visible() { return thumbs.filter(function (t) { return t.style.display !== 'none'; }); }
  function step(dir) {
    var v = visible();
    if (v.length < 2) return;
    var cur = 0;
    v.forEach(function (t, i) { if (t.classList.contains('is-active')) cur = i; });
    show(v[(cur + dir + v.length) % v.length].dataset.index);
  }
  var pv = root.querySelector('[data-vb-prev]'), nx = root.querySelector('[data-vb-next]');
  if (pv) pv.addEventListener('click', function () { step(-1); });
  if (nx) nx.addEventListener('click', function () { step(1); });

  /* Vegen en slepen in de hoofdgalerij. Bewust ZONDER pointer-capture: het gaat hier om een
     gebaar van links naar rechts, niet om een strook die meebeweegt, en capture heeft eerder
     de hele pagina onklikbaar gemaakt toen de muisknop buiten het venster losgelaten werd. */
  var podium = root.querySelector('.vbp__stage');
  if (podium) {
    var gX = 0, gY = 0, gBezig = false;
    /* Een afbeelding is van nature versleepbaar. Laat je dat toe, dan kaapt de browser het
       gebaar en komt er nooit een pointerup, waardoor het vegen niets doet. */
    podium.addEventListener('dragstart', function (e) { e.preventDefault(); });
    podium.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      gX = e.clientX; gY = e.clientY; gBezig = true;
    });
    podium.addEventListener('pointerup', function (e) {
      if (!gBezig) return;
      gBezig = false;
      var dx = e.clientX - gX, dy = e.clientY - gY;
      /* alleen een duidelijk horizontaal gebaar telt, zodat verticaal scrollen niet blaadert */
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      step(dx < 0 ? 1 : -1);
    });
    podium.addEventListener('pointercancel', function () { gBezig = false; });
    podium.addEventListener('pointerleave', function () { gBezig = false; });
  }

  /* ---------- taalkeuze stuurt galerij, fragment en prijs ---------- */
  function filterLang(lang) {
    var any = thumbs.some(function (t) { return t.dataset.lang === lang; });
    var first = null;
    thumbs.forEach(function (t) {
      var ok = !any || t.dataset.lang === lang;
      t.style.display = ok ? '' : 'none';
      if (ok && first === null) first = t.dataset.index;
    });
    if (first !== null) show(first);
    var anyFrag = frags.some(function (f) { return f.dataset.fragLang === lang; });
    frags.forEach(function (f) { f.style.display = (!anyFrag || f.dataset.fragLang === lang) ? '' : 'none'; });
    fragDl.forEach(function (d) { d.style.display = (d.dataset.fragLang === lang) ? '' : 'none'; });
    var many = visible().length > 1;
    [pv, nx].forEach(function (b) { if (b) b.style.display = many ? '' : 'none'; });
    ververs();
  }
  if (picker) {
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('.vbp__langbtn');
      if (!b) return;
      picker.querySelectorAll('.vbp__langbtn').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (idInput) idInput.value = b.dataset.variantId;
      if (amount)  amount.textContent  = b.dataset.price;
      if (bbPrice) bbPrice.textContent = b.dataset.price;
      if (bbMeta)  bbMeta.textContent  = b.textContent.trim() + bbMeta.textContent.slice(bbMeta.textContent.indexOf(','));
      filterLang(b.dataset.vbLang);
    });
    var act = picker.querySelector('.vbp__langbtn.is-active');
    if (act) filterLang(act.dataset.vbLang);
  }

  /* ---------- fragmentstrip ---------- */
  var strip = root.querySelector('[data-vb-fragstrip]');
  var bar   = root.querySelector('[data-frag-bar]');
  function fragBar() {
    if (!strip || !bar) return;
    /* Zelfde eenvoud als in de catalogus: positie in procenten van het spoor. De vorige
       versie rekende met pixels en de eigen breedte van de balk, wat bij een geklemde
       breedte niet exact op het eind uitkwam. */
    var max = strip.scrollWidth - strip.clientWidth;
    var w = max > 0 ? Math.max(12, Math.min(100, (strip.clientWidth / strip.scrollWidth) * 100)) : 100;
    var frac = max > 0 ? Math.min(1, Math.max(0, Math.abs(strip.scrollLeft) / max)) : 0;
    bar.style.width = w + '%';
    if (rtl) { bar.style.right = (frac * (100 - w)) + '%'; bar.style.left = 'auto'; }
    else { bar.style.left = (frac * (100 - w)) + '%'; bar.style.right = 'auto'; }
    bar.style.transform = 'none';
  }
  var fp = root.querySelector('[data-frag-prev]'), fn = root.querySelector('[data-frag-next]');
  var sleepte = false;

  /* Aan het begin en aan het eind van de rij dooft de bijbehorende pijl, zodat de
     bezoeker ziet dat er niet verder te bladeren valt. Buiten het if-blok gedefinieerd,
     want de taalkeuze roept dit ook aan als de rij van inhoud wisselt. */
  function maxScroll() { return strip ? Math.max(0, strip.scrollWidth - strip.clientWidth) : 0; }
  function randen() {
    if (!strip || !fp || !fn) return;
    var p = Math.abs(strip.scrollLeft), mx = maxScroll();
    fp.disabled = p < 2;
    fn.disabled = p >= mx - 2;
  }
  function ververs() { fragBar(); randen(); }

  if (strip) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    strip.addEventListener('scroll', ververs, { passive: true });
    window.addEventListener('resize', ververs);
    ververs();

    /* Naar welke stand moet de rij inzakken: de dichtstbijzijnde pagina links uitgelijnd.
       Rect-gebaseerd gemeten, want scrollLeft telt in rechts-naar-links negatief. */
    function dichtstbij() {
      var zichtbaar = frags.filter(function (f) { return f.style.display !== 'none'; });
      if (!zichtbaar.length) return strip.scrollLeft;
      var s = strip.getBoundingClientRect(), best = strip.scrollLeft, bestD = Infinity;
      zichtbaar.forEach(function (f) {
        var d = f.getBoundingClientRect()[rtl ? 'right' : 'left'] - s[rtl ? 'right' : 'left'];
        if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = strip.scrollLeft + d; }
      });
      return best;
    }

    var anim = 0;
    function stopAnim() { if (anim) { cancelAnimationFrame(anim); anim = 0; } }

    /* Uitrollen met afremming en daarna zacht op een pagina inzakken, in één animatie.
       Zelfde gedrag als de laptopschermen in het Webdesign Atelier. */
    function glijden(v0) {
      stopAnim();
      if (reduce) { strip.scrollLeft = dichtstbij(); strip.classList.remove('is-glide'); ververs(); return; }
      strip.classList.add('is-glide');
      var pos = strip.scrollLeft, v = v0 || 0, vast = null;
      function frame() {
        if (vast === null) {
          var voor = strip.scrollLeft;
          pos += v; v *= 0.935;
          strip.scrollLeft = pos;
          pos = strip.scrollLeft;                       /* de browser klemt aan de randen af */
          if (Math.abs(pos - voor) < 0.5 && Math.abs(v) > 0.7) v = 0;
          if (Math.abs(v) < 0.7) vast = dichtstbij();
          ververs();
          anim = requestAnimationFrame(frame);
          return;
        }
        pos += (vast - pos) * 0.17;
        strip.scrollLeft = pos;
        if (Math.abs(vast - pos) < 0.5) {
          strip.scrollLeft = vast; anim = 0;
          strip.classList.remove('is-glide');
          ververs();
          return;
        }
        ververs();
        anim = requestAnimationFrame(frame);
      }
      anim = requestAnimationFrame(frame);
    }

    /* ---- slepen met de muis, aanraken houdt het native scrollen ---- */
    var neer = false, startX = 0, startLeft = 0, laatstX = 0, laatstT = 0, snelheid = 0;
    var pid = null, gevangen = false;
    var raf = 0, wachtX = null;
    function nu() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

    /* De browser mag geen eigen sleepactie op de link starten, die breekt de capture af. */
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });

    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      stopAnim();
      strip.classList.remove('is-glide');
      neer = true; sleepte = false;
      startX = e.clientX; startLeft = strip.scrollLeft;
      laatstX = e.clientX; laatstT = nu(); snelheid = 0;
      pid = e.pointerId; gevangen = false;
      strip.classList.add('is-drag');
    });
    strip.addEventListener('pointermove', function (e) {
      if (!neer) return;
      /* Vangnet. Wordt de muisknop buiten het venster losgelaten, dan bereikt pointerup de
         pagina nooit en blijft de capture op de strook staan. Vanaf dat moment gaat ELKE
         klik op de pagina naar de strook en werkt niets meer. Beweegt de muis terwijl er
         geen knop ingedrukt is, dan is de sleep dus voorbij. */
      if (e.buttons === 0) { losLaten(); return; }
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) {
        sleepte = true;
        /* Pointer-capture houdt elke beweging bij de strook, ook als de muis over een foto
           gaat of de rij verlaat. Pas AAN het begin van een echte sleep zetten, want zolang
           de capture actief is landt ook de klik op de strook in plaats van op de foto, en
           dan opent de vergrootbox niet meer. */
        if (!gevangen) { try { strip.setPointerCapture(pid); gevangen = true; } catch (err) {} }
      }
      var t = nu(), dt = t - laatstT;
      /* gedempt meten, zodat een trilling van de hand niet doorslaat in de zwaai */
      if (dt > 0) { snelheid = snelheid * 0.7 + ((e.clientX - laatstX) / dt) * 0.3; laatstX = e.clientX; laatstT = t; }
      wachtX = startLeft - dx;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; if (wachtX !== null) { strip.scrollLeft = wachtX; ververs(); } });
    });
    function losLaten() {
      if (!neer) return;
      neer = false;
      if (gevangen && pid !== null) {
        try { strip.releasePointerCapture(pid); } catch (err) { /* al vrijgegeven */ }
      }
      gevangen = false; pid = null;
      if (raf) { cancelAnimationFrame(raf); raf = 0; if (wachtX !== null) strip.scrollLeft = wachtX; }
      wachtX = null;
      strip.classList.remove('is-drag');
      if (!sleepte) return;
      if (nu() - laatstT > 90) snelheid = 0;   /* even stilstaan telt als loslaten zonder zwaai */
      glijden(-snelheid * 16);
      setTimeout(function () { sleepte = false; }, 80);
    }
    strip.addEventListener('pointerup', losLaten);
    strip.addEventListener('pointercancel', losLaten);
    strip.addEventListener('lostpointercapture', losLaten);
    window.addEventListener('pointerup', losLaten);       /* vangnet als capture niet lukte */
    /* Alt-tab, een ander venster, of het tabblad naar de achtergrond: sleep beeindigen. */
    window.addEventListener('blur', losLaten);
    document.addEventListener('visibilitychange', function () { if (document.hidden) losLaten(); });
    /* Een nieuwe druk terwijl er nog een sleep openstaat: eerst opruimen. */
    window.addEventListener('pointerdown', function () { if (neer) losLaten(); }, true);

    /* Na een sleep mag de vergrootbox niet openen. In de capture-fase, dus vóór de
       klik op de fragmentpagina zelf. */
    strip.addEventListener('click', function (e) {
      if (sleepte) { e.stopPropagation(); e.preventDefault(); sleepte = false; }
    }, true);

    /* ---- toetsenbord en de pijlknoppen ---- */
    strip.setAttribute('tabindex', '0');
    strip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); schuif(rtl ? -1 : 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); schuif(rtl ? 1 : -1); }
    });
    function schuif(dir) {
      stopAnim();
      strip.classList.remove('is-glide');
      strip.scrollBy({ left: dir * Math.round(strip.clientWidth * 0.8) * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(ververs, 380);
    }
    if (fp) fp.addEventListener('click', function () { schuif(-1); });
    if (fn) fn.addEventListener('click', function () { schuif(1); });
  }

  /* ---------- vergrootbox ---------- */
  var lb = root.querySelector('[data-vb-lb]'), lbImg = root.querySelector('[data-lb-img]'), lbIdx = 0;
  function shown() { return frags.filter(function (f) { return f.style.display !== 'none'; }); }
  function openLb(i) {
    var list = shown();
    if (!list.length) return;
    lbIdx = (i + list.length) % list.length;
    lbImg.src = list[lbIdx].dataset.full;
    lbImg.alt = list[lbIdx].getAttribute('aria-label') || '';
    lb.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  function closeLb() { lb.classList.remove('is-on'); document.body.style.overflow = ''; }
  /* Via de strook in plaats van per foto. Bij een sleep is de capture actief en landt de
     klik op de strook, dus een handler op de foto zelf zou hem missen. De onderdrukking
     na een sleep zit in de capture-fase en stopt deze afhandeling dus vanzelf. */
  if (strip) {
    strip.addEventListener('click', function (e) {
      var kaart = e.target && e.target.closest ? e.target.closest('.vbp__fragpage') : null;
      if (!kaart) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;   /* nieuw tabblad met rust laten */
      e.preventDefault();
      openLb(shown().indexOf(kaart));
    });
  }
  if (lb) {
    root.querySelector('[data-lb-close]').addEventListener('click', closeLb);
    root.querySelector('[data-lb-prev]').addEventListener('click', function () { openLb(lbIdx - 1); });
    root.querySelector('[data-lb-next]').addEventListener('click', function () { openLb(lbIdx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-on')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') openLb(lbIdx + 1);
      if (e.key === 'ArrowLeft')  openLb(lbIdx - 1);
    });
  }

  /* ---------- sticky koopbalk ---------- */
  var hero = root.querySelector('[data-vb-hero]');
  var bb   = root.querySelector('[data-vb-buybar]');
  var form = root.querySelector('form');
  var bbBtn = root.querySelector('[data-vb-bbbtn]');
  /* ---------- herroepingsvakjes ----------
     Het vakje moet aan staan voordat er besteld kan worden. Het required-attribuut doet dit
     ook zonder script; hier maken we er een zichtbare melding van in plaats van een
     browsertooltip, en zetten we het tijdstip van akkoord in de bestelling. */
  var hrBoxes = [].slice.call(root.querySelectorAll('[data-vb-hrbox]'));
  var hrNodig = root.querySelector('[data-vb-hrnodig]');
  var hrTijd  = root.querySelector('[data-vb-hrtijd]');
  var addBtn  = root.querySelector('[data-vb-addbtn]');

  function hrCompleet() {
    return hrBoxes.length > 0 && hrBoxes.every(function (b) { return b.checked; });
  }
  function hrBijwerken() {
    var ok = hrCompleet();
    /* Bewust GEEN aria-disabled en geen disabled: dan meldt een schermlezer 'uitgeschakeld',
       probeert de bezoeker het niet, en hoort hij nooit waaróm er niets gebeurt. De knop
       blijft dus klikbaar en verwijst naar de melding die vertelt wat er nog moet. */
    if (addBtn) {
      addBtn.classList.toggle('is-geblokkeerd', !ok);
      if (ok) addBtn.removeAttribute('aria-describedby');
      else if (hrNodig && hrNodig.id) addBtn.setAttribute('aria-describedby', hrNodig.id);
    }
    if (bbBtn) bbBtn.classList.toggle('is-geblokkeerd', !ok);
    if (ok && hrNodig) hrNodig.hidden = true;
    if (ok && hrTijd && !hrTijd.value) hrTijd.value = new Date().toISOString().replace('T', ' ').slice(0, 19) + ' UTC';
    if (!ok && hrTijd) hrTijd.value = '';
  }
  function hrWeigeren(e) {
    if (hrCompleet()) return false;
    e.preventDefault();
    if (hrNodig) hrNodig.hidden = false;
    var eerste = hrBoxes.filter(function (b) { return !b.checked; })[0];
    if (eerste) {
      eerste.focus();
      var vak = eerste.closest('.vbp__hr-vak');
      if (vak) { vak.classList.add('is-mist'); setTimeout(function () { vak.classList.remove('is-mist'); }, 1200); }
      eerste.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return true;
  }
  /* Het required-attribuut beschermt zonder script, maar dan wint de browservalidatie en
     krijgt de bezoeker een kale tooltip in plaats van onze uitleg. Draait het script wel,
     dan zetten we die validatie uit en nemen wij de melding voor onze rekening. */
  if (form && hrBoxes.length) form.noValidate = true;
  hrBoxes.forEach(function (b) { b.addEventListener('change', hrBijwerken); });
  if (form) form.addEventListener('submit', hrWeigeren);
  hrBijwerken();

  if (bbBtn && form) bbBtn.addEventListener('click', function (e) {
    if (hrWeigeren(e)) return;              /* de sticky balk mag er niet omheen */
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  if (hero && bb && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var on = !entries[0].isIntersecting;
      bb.classList.toggle('is-on', on);
      bb.setAttribute('aria-hidden', on ? 'false' : 'true');
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
  }

  /* ---------- ankerrail volgt de scroll ---------- */
  var items = [].slice.call(root.querySelectorAll('[data-vb-railitem]'));
  var secs  = items.map(function (a) { return root.querySelector('#' + a.dataset.vbRailitem); }).filter(Boolean);
  if (secs.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        items.forEach(function (a) { a.classList.toggle('is-active', a.dataset.vbRailitem === en.target.id); });
      });
    }, { rootMargin: '-96px 0px -70% 0px' });
    secs.forEach(function (s) { io.observe(s); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnk-yasa-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-bnk-lightbox]'));
  var box = document.getElementById('bnk-yasa-lightbox');
  if (!imgs.length || !box) return;
  var boxImg = box.querySelector('.bnk-yasa-lightbox__img');
  var cap = box.querySelector('.bnk-yasa-lightbox__caption');
  var current = 0;

  function captionFor(img) {
    var fig = img.closest('figure');
    var fc = fig ? fig.querySelector('figcaption') : null;
    return fc ? fc.textContent : (img.getAttribute('alt') || '');
  }
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    boxImg.src = imgs[current].src;
    boxImg.alt = imgs[current].alt || '';
    cap.textContent = captionFor(imgs[current]);
  }
  function open(i) { show(i); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  imgs.forEach(function(img, i) {
    img.addEventListener('click', function() { open(i); });
  });
  box.querySelector('.bnk-yasa-lightbox__close').addEventListener('click', close);
  box.querySelector('.bnk-yasa-lightbox__nav--prev').addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.bnk-yasa-lightbox__nav--next').addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
  box.addEventListener('click', function(e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function(e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Scrollspy: licht in de ankernavigatie op welke sectie in beeld is, zodat duidelijk is
   dat dit een klikbaar menu is en waar je je bevindt. */
(function() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.bnk-yasa-nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function(a) {
    var id = (a.getAttribute('href') || '').replace('#', '');
    var el = id && document.getElementById(id);
    if (el) { map[id] = a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var a = map[e.target.id];
      if (!a || a === current) return;
      if (current) current.classList.remove('is-current');
      a.classList.add('is-current');
      current = a;
    });
  }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
  targets.forEach(function(t) { obs.observe(t); });
})();

/* Zwevende "naar boven"-knop: verschijnt zodra je begint te scrollen, scrolt soepel omhoog. */
(function() {
  var btn = document.querySelector('.bnk-yasa-top');
  if (!btn) return;
  var THRESHOLD = 260;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    btn.classList.toggle('is-visible', y > THRESHOLD);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

/* Peek-carousel(s) met veeg/sleep, pijlen, dots en chips. Actieve slide gecentreerd,
   buren pieken links en rechts. Initialiseert ELKE [data-swipe] onafhankelijk. */
(function() {
  function initSwipe(root) {
  var vp = root.querySelector('.bnk-yasa-swipe__vp');
  var track = root.querySelector('.bnk-yasa-swipe__track');
  var slides = Array.prototype.slice.call(track.querySelectorAll('.bnk-yasa-swipe__slide'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.bnk-yasa-swipe__chip'));
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var n = slides.length;
  if (!n) return;
  var index = 0;

  var dots = slides.map(function(_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'bnk-yasa-swipe__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Ga naar weergave ' + (i + 1));
    d.addEventListener('click', function() { go(i); });
    dotsWrap.appendChild(d);
    return d;
  });

  function step() {
    if (n < 2) return vp.clientWidth;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }
  function baseOffset() {
    var s = slides[index];
    return (vp.clientWidth / 2) - (s.offsetLeft + s.offsetWidth / 2);
  }
  function render(extra) {
    extra = extra || 0;
    track.style.transform = 'translate3d(' + (baseOffset() + extra) + 'px,0,0)';
    slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
    chips.forEach(function(c, i) {
      var on = i === index;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === n - 1;
  }
  function go(i) {
    index = Math.max(0, Math.min(n - 1, i));
    track.style.transition = '';
    render(0);
  }

  prevBtn.addEventListener('click', function() { go(index - 1); });
  nextBtn.addEventListener('click', function() { go(index + 1); });
  chips.forEach(function(c, i) { c.addEventListener('click', function() { go(i); }); });

  // Slepen / vegen
  var dragging = false, startX = 0, dx = 0, moved = false, pid = null;
  function down(x, e) {
    dragging = true; moved = false; startX = x; dx = 0;
    track.style.transition = 'none';
    if (e && e.pointerId != null) { pid = e.pointerId; try { vp.setPointerCapture(pid); } catch (_) {} }
  }
  function move(x) {
    if (!dragging) return;
    dx = x - startX;
    if (Math.abs(dx) > 6) moved = true;
    render(dx);
  }
  function up() {
    if (!dragging) return;
    dragging = false;
    if (pid != null) { try { vp.releasePointerCapture(pid); } catch (_) {} pid = null; }
    var st = step() || 1;
    var jump = Math.round(-dx / st);
    if (jump === 0 && Math.abs(dx) > st * 0.18) jump = dx < 0 ? 1 : -1;
    go(index + jump);
  }
  if (window.PointerEvent) {
    vp.addEventListener('pointerdown', function(e) { if (e.button != null && e.button !== 0) return; down(e.clientX, e); });
    vp.addEventListener('pointermove', function(e) { if (dragging) move(e.clientX); });
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
  } else {
    vp.addEventListener('touchstart', function(e) { down(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchmove', function(e) { move(e.touches[0].clientX); }, { passive: true });
    vp.addEventListener('touchend', up);
    vp.addEventListener('mousedown', function(e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }
  // Klik onderdrukken direct na een sleep (anders opent de lightbox ongewild)
  vp.addEventListener('click', function(e) {
    if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
  }, true);

  // Toetsenbord
  vp.setAttribute('tabindex', '0');
  vp.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
  });

  window.addEventListener('resize', function() { track.style.transition = 'none'; render(0); });
  render(0);
  window.addEventListener('load', function() { render(0); });
  slides.forEach(function(s) {
    var img = s.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function() { render(0); });
  });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-swipe]')).forEach(initSwipe);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
